<template>
  <div class="live-console">
    <div class="main-content">
      <!-- 左侧面板 -->
      <div class="side-panel left">
        <!-- 素材选择 -->
        <div class="panel-card tech-card material-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M2 6h12M2 10h12" stroke="#4ecdc4" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="5" cy="6" r="1.5" fill="#ff6b6b"/>
                <circle cx="11" cy="10" r="1.5" fill="#ffe66d"/>
              </svg>
            </div>
            <span>直播视频</span>
            <button class="reset-link-btn" @click="resetMaterial">恢复默认</button>
          </div>
          <div class="card-body">
            <!-- 主视频 -->
            <div class="material-section">
              <div class="material-top-row">
                <span class="material-label">选择视频</span>
                <select class="select" v-model="material.source" style="flex: 1;">
                  <option value="local">本地视频</option>
                  <option value="cloud">实时转播</option>
                </select>
                <span class="material-label">播放模式</span>
                <select class="select" v-model="material.playMode" style="flex: 1;">
                  <option value="sequence">顺序播放</option>
                  <option value="random">随机播放</option>
                </select>
              </div>
              <div class="path-input-wrapper">
                <input
                    type="text"
                    class="path-input"
                    v-model="materialInitialPath"
                    :title="materialInitialPath"
                    placeholder="请输入完整路径或将文件拖到此处..."
                    @dragover.prevent
                    @drop.prevent="handleDrop($event, 'material')"
                    @keyup.enter="handlePathEnter"
                />
                <input type="file" ref="fileInput" style="display: none" @change="handleFileSelect"/>
                <input type="file" ref="folderInput" style="display: none" webkitdirectory directory
                       @change="handleFolderSelect"/>
                <div class="path-input-actions">
                  <button class="path-btn add-file" @click="addFile" title="添加文件">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M4 3h4l2 2h3v8H4V3z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round"/>
                      <path d="M8 7h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      <path d="M8 10h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      <path d="M5 7h1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      <path d="M5 10h1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                  </button>
                  <button class="path-btn add-folder" @click="addFolder" title="添加文件夹">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 4h5l2 2h3v6H3V4z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 遮罩视频独立卡片 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M2 4h12M2 8h12M2 12h12" stroke="#95e1d3" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="5" cy="8" r="1.5" fill="#a29bfe"/>
              </svg>
            </div>
            <span>遮罩视频</span>
            <button class="reset-link-btn" @click="resetOverlay">恢复默认</button>
          </div>
          <div class="card-body">
            <div class="material-section">
              <div class="material-top-row">
                <span class="material-label">选择视频</span>
                <select class="select" v-model="overlay.source" style="flex: 1;">
                  <option value="local">本地视频</option>
                  <option value="cloud">实时转播</option>
                </select>
                <span class="material-label">播放模式</span>
                <select class="select" v-model="overlay.playMode" style="flex: 1;">
                  <option value="sequence">顺序播放</option>
                  <option value="random">随机播放</option>

                </select>
              </div>
              <div class="path-input-wrapper">
                <input
                    type="text"
                    class="path-input"
                    v-model="overlayInitialPath"
                    :title="overlayInitialPath"
                    placeholder="请输入完整路径或将文件拖到此处..."
                    @dragover.prevent
                    @drop.prevent="handleDrop($event, 'overlay')"
                    @keyup.enter="handleOverlayPathEnter"
                />
                <input type="file" ref="overlayFileInput" style="display: none" @change="handleOverlayFileSelect"/>
                <input type="file" ref="overlayFolderInput" style="display: none" webkitdirectory directory
                       @change="handleOverlayFolderSelect"/>
                <div class="path-input-actions">
                  <button class="path-btn add-file" @click="addOverlayFile" title="添加文件">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M4 3h4l2 2h3v8H4V3z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round"/>
                      <path d="M8 7h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      <path d="M8 10h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      <path d="M5 7h1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      <path d="M5 10h1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                  </button>
                  <button class="path-btn add-folder" @click="addOverlayFolder" title="添加文件夹">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 4h5l2 2h3v6H3V4z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              </div>
              <!-- 音量与透明度一行显示 -->
              <div class="tech-controls-inline">
                <div class="tech-control-item">
                  <span class="material-label">音量</span>
                  <div class="slider-wrapper">
                    <input type="range" v-model="overlay.volume" min="0" max="100" class="tech-slider"/>
                    <span class="tech-value">{{ overlay.volume }}%</span>
                  </div>
                </div>
                <div class="tech-control-item">
                  <span class="material-label">透明度</span>
                  <div class="slider-wrapper">
                    <input type="range" v-model="overlay.opacity" min="0" max="100" class="tech-slider"/>
                    <span class="tech-value">{{ overlay.opacity }}%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 遮罩特效独立卡片 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M2 4h12M2 8h12M2 12h12" stroke="#ff9f43" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M4 2v12M8 2v12M12 2v12" stroke="#4ecdc4" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <span>遮罩特效</span>
            <label class="header-toggle">
              <input type="checkbox" v-model="effects.enabled"/>
              <span class="toggle-track"></span>
            </label>
          </div>
          <div class="card-body">
            <div class="effects-row-main">
              <span class="material-label">选择特效</span>
              <select class="select" v-model="effects.type">
                <option value="字幕雨">字幕雨</option>
                <option value="雪花">雪花</option>
                <option value="星空">星空</option>
                <option value="动态杂点">动态杂点</option>
                <option value="粒子线条">粒子线条</option>
                <option value="彩色光斑">彩色光斑</option>
                <option value="动态扫描线">动态扫描线</option>
                <option value="混沌透视重塑">混沌透视重塑</option>

                <option value="色彩偏移">色彩偏移</option>
                <option value="边缘流光">边缘流光</option>
                <option value="AI像素重组">AI像素重组</option>
              </select>

              <span class="material-label">播放模式</span>
              <select class="select" v-model="effects.playMode">
                <option value="fixed">固定播放</option>
                <option value="sequence">顺序播放</option>
                <option value="random">随机播放</option>
              </select>
            </div>

            <div class="effects-slider-group">
              <div class="slider-label">透明度</div>
              <div class="effects-slider-wrapper">
                <input type="range" v-model="effects.opacity" min="0" max="100" class="effects-slider"/>
                <span class="tech-value">{{ effects.opacity }}%</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 图片遮罩独立卡片 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M14 12V4a1 1 0 00-1-1H2a1 1 0 00-1 1v8a1 1 0 001 1h11a1 1 0 001-1z" stroke="#4ecdc4"
                      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="4.5" cy="6.5" r="1.5" stroke="#ff6b6b" stroke-width="1.5"/>
                <path d="M14 10l-3.5-3.5L6 11l-2-2-3 3" stroke="#ffe66d" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
              </svg>
            </div>
            <span>图片遮罩</span>
            <label class="header-toggle">
              <input type="checkbox" v-model="imageOverlay.enabled"/>
              <span class="toggle-track"></span>
            </label>
          </div>
          <div class="card-body">
            <div class="material-section" style="margin-bottom: 0;">
              <div class="material-top-row" style="gap: 16px;">
                <div class="path-input-wrapper" style="flex: 0.6; margin-top: 0;">
                  <input
                      type="text"
                      class="path-input"
                      v-model="imageOverlay.path"
                      :title="imageOverlay.path"
                      placeholder="请输入完整路径或将文件夹拖到此处..."
                      @dragover.prevent
                      @drop.prevent="handleDrop($event, 'imageOverlay')"
                  />
                  <input type="file" ref="imageOverlayFolderInput" style="display: none" webkitdirectory directory
                         @change="handleImageFolderSelect"/>
                  <div class="path-input-actions">
                    <button class="path-btn add-folder" @click="addImageFolder" title="添加文件夹">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M3 4h5l2 2h3v6H3V4z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                              stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="effects-slider-group" style="margin-top: 0; margin-bottom: 0; flex: 1.9;">
                  <div class="slider-label">透明度</div>
                  <div class="effects-slider-wrapper">
                    <input type="range" v-model="imageOverlay.opacity" min="0" max="100" class="effects-slider"/>
                    <span class="tech-value">{{ imageOverlay.opacity }}%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 本地摄像头独立卡片 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M13 5l-3 2.25V5a1 1 0 00-1-1H3a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1V8.75L13 11V5z"
                      stroke="#95e1d3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="6" cy="7.5" r="1.5" fill="#ff6b6b"/>
              </svg>
            </div>
            <span>本机真实摄像头</span>
            <label class="header-toggle">
              <input type="checkbox" v-model="camera.enabled"/>
              <span class="toggle-track"></span>
            </label>
          </div>
          <div class="card-body">
            <div class="effects-row-main">
              <span class="material-label">摄像头</span>
              <div class="camera-select-wrapper" style="display: flex; gap: 8px; width: 44%;">
                <select class="select" v-model="camera.device" style="flex: 1;">
                  <option v-for="device in camera.devices" :key="device.deviceId" :value="device.deviceId">
                    {{ device.label || `摄像头 ${camera.devices.indexOf(device) + 1}` }}
                  </option>
                  <option v-if="camera.devices.length === 0" value="">未检测到摄像头</option>
                </select>
              </div>
              <div class="tech-control-item" style="flex: 1;">
                <span class="material-label">透明度</span>
                <div class="slider-wrapper">
                  <input type="range" v-model="camera.opacity" min="0" max="100" class="tech-slider"/>
                  <span class="tech-value">{{ camera.opacity }}%</span>
                </div>
              </div>
            </div>
            <div class="effects-header" style="margin-top: 12px; font-size: 12px; color: #888;">
              提示：开启后可在画面上拖动移动位置，拖动四角调整大小
            </div>
          </div>
          <!-- 隐藏的音画同步控制（保持界面整洁） -->
          <div v-show="false">
            <input type="range" v-model.number="audioSettings.syncOffset" min="-500" max="500" step="10">
          </div>
        </div>
      </div>

      <!-- 中间面板 -->
      <div class="center-panel">

        <!-- 视频预览区 -->
        <div class="video-area">
          <div class="video-preview">
            <div class="video-bg">
              <!-- 本机真实摄像头画面 -->
              <div
                v-if="camera.enabled"
                class="camera-container"
                :style="{
                  position: 'absolute',
                  left: camera.position.x + 'px',
                  top: camera.position.y + 'px',
                  width: camera.size.width + 'px',
                  height: camera.size.height + 'px',
                  zIndex: 20
                }"
              >
                <video
                  ref="localCameraVideo"
                  class="local-camera-video"
                  playsinline
                  autoplay
                  muted
                  :style="{
                    width: '100%',
                    height: '100%',
                    borderRadius: '8px',
                    objectFit: 'cover',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                    opacity: camera.opacity / 100
                  }"
                ></video>
                
                <!-- 透明覆盖层，用于处理拖动 -->
                <div
                  class="camera-overlay"
                  @mousedown="handleCameraMouseDown"
                ></div>
                
                <!-- 选中时的边框和调整节点 -->
                <template v-if="camera.selected">
                  <!-- 四角调整节点 -->
                  <div
                    class="resize-handle resize-handle-tl"
                    @mousedown="handleResizeStart($event, 'tl')"
                    style="top: -4px; left: -4px;"
                  ></div>
                  <div
                    class="resize-handle resize-handle-tr"
                    @mousedown="handleResizeStart($event, 'tr')"
                    style="top: -4px; right: -4px;"
                  ></div>
                  <div
                    class="resize-handle resize-handle-bl"
                    @mousedown="handleResizeStart($event, 'bl')"
                    style="bottom: -4px; left: -4px;"
                  ></div>
                  <div
                    class="resize-handle resize-handle-br"
                    @mousedown="handleResizeStart($event, 'br')"
                    style="bottom: -4px; right: -4px;"
                  ></div>
                </template>
              </div>
              <!-- 运镜层 -->
              <div class="motion-wrapper" :style="cameraMotionStyle">

                  <!-- 核心播放器：使用 canvas 渲染 -->
                  <canvas
                      ref="videoCanvas"
                      class="video-element"
                      :style="{ 
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        opacity: 1,
                        pointerEvents: 'auto',
                        zIndex: 1, // 视频在最底层
                        ...mainVideoEffectsStyle 
                      }"
                  ></canvas>
                  
                  <!-- 透明点击层：确保可以点击播放视频 -->

                  

                  <!-- 驱动启动中的加载提示 -->
                  <div v-if="isStarting" class="video-loading-overlay">
                    <div class="loading-spinner-large"></div>
                    <div class="loading-text">正在初始化驱动引擎...</div>
                  </div>

                  <!-- 特效渲染层 (现在合并到 videoCanvas 中) -->
                  <canvas
                      v-if="false"
                      ref="effectsCanvas"
                      class="effects-canvas"
                  ></canvas>
                  



                  <!-- 虚拟摄像头在线提示 -->
                  <div v-if="isVirtualCameraLive" class="video-overlay">
                    <div class="live-badge">
                      <span class="live-dot"></span>
                      {{ cameraSettings.name }} 正在推流中
                      <span v-if="isLiteMode" style="font-size: 10px; opacity: 0.7; margin-left: 4px;">(预览模式)</span>
                    </div>
                  </div>


              </div>
              <!-- 摄像头画面层 -->
              <div
                  v-if="camera.enabled"
                  class="camera-wrapper"
                  :class="{ 'camera-selected': camera.selected }"
                  :style="{
                  left: camera.position.x + 'px',
                  top: camera.position.y + 'px',
                  width: camera.size.width + 'px',
                  height: camera.size.height + 'px',
                  zIndex: camera.zIndex
                }"
              >
                <video
                    ref="cameraVideoElement"
                    class="camera-video-element"
                    autoplay
                    playsinline
                    muted
                    :style="{ opacity: camera.opacity / 100 }"
                ></video>
                <!-- 透明覆盖层，用于处理拖动 -->
                <div
                    class="camera-overlay"
                    @mousedown="handleCameraMouseDown"
                ></div>
                <!-- 四个角落的调整手柄 - 选中时显示 -->
                <template v-if="camera.selected">
                  <div class="resize-handle resize-handle-tl" @mousedown.stop="handleResizeStart($event, 'tl')"></div>
                  <div class="resize-handle resize-handle-tr" @mousedown.stop="handleResizeStart($event, 'tr')"></div>
                  <div class="resize-handle resize-handle-bl" @mousedown.stop="handleResizeStart($event, 'bl')"></div>
                  <div class="resize-handle resize-handle-br" @mousedown.stop="handleResizeStart($event, 'br')"></div>
                </template>
              </div>
            </div>
            <div class="video-grid"></div>
          </div>

          <!-- 视频下方控制栏 -->
          <div class="video-controls-new">
            <!-- 进度条 -->
            <div class="progress-container" @click.stop="seekVideo">
              <div class="progress-bar-bg">
                <div class="progress-bar-fill" :style="{ width: (currentTime / duration * 100) + '%' }"></div>
              </div>
            </div>

            <div class="controls-main-row">
              <div class="control-left">
                <button class="control-btn-new play" @click.stop="togglePlay">
                  <svg v-if="!isPlaying" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M6 4v10l8-5z" fill="currentColor"/>
                  </svg>
                  <svg v-else width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M6 4h2v10H6zM10 4h2v10h-2z" fill="currentColor"/>
                  </svg>
                </button>
                <span class="time-display-new">{{ formatTime(currentTime) }} / {{ formatTime(duration) }}</span>
              </div>

              <div class="control-right">
                <div class="volume-control-mini main-player-volume">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                       stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                    <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                  </svg>
                  <input type="range" v-model="material.volume" min="0" max="100" class="mini-slider"/>
                  <span class="mini-value">{{ material.volume }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 设备设置区 -->
        <div class="device-settings-area">
          <div class="device-row">
            <div class="device-label-box">摄像头名称</div>
            <input type="text" class="device-input" v-model="cameraSettings.name" placeholder="输入虚拟摄像头名称..."/>
            <button class="device-action-btn apply" :class="{ 'is-loading': isStarting }" @click="applyCameraSettings">
              <svg v-if="!isStarting" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                <circle cx="12" cy="13" r="4"></circle>
              </svg>
              <span v-else class="loading-spinner"></span>
              {{ isStarting ? '正在启动...' : (isVirtualCameraLive ? '停止驱动' : '启动驱动') }}
            </button>

          </div>
          <div class="device-row">
            <div class="device-label-box">音频输出驱动</div>
            <div style="display: flex; gap: 12px; flex: 1; align-items: center;">
              <select class="device-select" v-model="audioSettings.driver" style="flex: 1; max-width: 97px;">
                <option v-for="(device, index) in audioDevices" :key="device.deviceId" :value="device.deviceId">
                  {{ device.label || `音频设备 ${index + 1}` }}
                </option>
              </select>
              <button class="path-btn" title="刷新列表" @click="enumerateAudioDevices" style="padding: 0 8px;">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round">
                  <path
                      d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </button>
              <button class="device-action-btn apply" title="手机转播" @click="openPhoneBroadcast">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round">
                  <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                  <line x1="12" y1="18" x2="12.01" y2="18"></line>
                </svg>

                手机转播
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧面板 -->
      <div class="side-panel right">
        <!-- 实时变速 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M1 8a7 7 0 1014 0A7 7 0 001 8z" stroke="#4ecdc4" stroke-width="1.5"/>
                <path d="M8 8L11 5" stroke="#ff6b6b" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="8" cy="8" r="1" fill="#ffe66d"/>
              </svg>
            </div>
            <span>实时变速</span>
            <label class="header-toggle">
              <input type="checkbox" v-model="playbackSpeed.enabled" :disabled="overlay_type=='cloud'"/>
              <span class="toggle-track"></span>
            </label>
          </div>
          <div class="card-body">
            <div class="time-row">
              <span>间隔</span>
              <input type="number" v-model.number="playbackSpeed.intervalStart" min="1"/>
              <span>到</span>
              <input type="number" v-model.number="playbackSpeed.intervalEnd" min="1"/>
              <span>秒</span>
              <select class="select" v-model="playbackSpeed.mode" style="width: 90px;">
                <option value="micro">微变速</option>
                <option value="medium">中变速</option>
                <option value="heavy">重变速</option>
              </select>
            </div>
          </div>
        </div>

        <!-- 实时抽帧 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3 3h10v10H3V3z" stroke="#ffe66d" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M3 7h6" stroke="#4ecdc4" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="11" cy="5" r="1" fill="#ff6b6b"/>
              </svg>
            </div>
            <span>实时抽帧</span>
            <label class="header-toggle">

              <input type="checkbox" v-model="frameCapture.enabled" :disabled="overlay_type=='cloud'"/>
              <span class="toggle-track"></span>
            </label>
          </div>
          <div class="card-body">
            <div class="fade-row">
              <span>间隔</span>
              <input type="number" v-model.number="frameCapture.intervalMin" min="1" max="60"/>
              <span>到</span>
              <input type="number" v-model.number="frameCapture.intervalMax" min="1" max="60"/>
              <span>秒</span>
              <select class="select" v-model="frameCapture.frameCount" style="width: 90px;">
                <option :value="1">抽1帧</option>
                <option :value="2">抽2帧</option>
                <option :value="3">抽3帧</option>
                <option :value="4">抽4帧</option>
                <option :value="5">抽5帧</option>
              </select>
            </div>
          </div>
        </div>

        <!-- 实时运镜 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="6" stroke="#a29bfe" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M8 5v6M5 8h6" stroke="#4ecdc4" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="8" cy="8" r="2" fill="#ff6b6b"/>
              </svg>
            </div>
            <span>实时运镜</span>
            <label class="header-toggle">
              <input type="checkbox" v-model="cameraMotion.enabled"/>
              <span class="toggle-track"></span>
            </label>
          </div>
          <div class="card-body">
            <div class="time-row">
              <span>间隔</span>
              <input type="number" v-model.number="cameraMotion.motionStart" min="1"/>
              <span>到</span>
              <input type="number" v-model.number="cameraMotion.motionEnd" min="1"/>
              <span>秒</span>
              <select class="select" v-model="cameraMotion.mode" style="width: 90px;">
                <option value="micro">微运镜</option>
                <option value="medium">中运镜</option>
                <option value="heavy">重运镜</option>
              </select>
            </div>
          </div>
        </div>

        <!-- 实时抖动 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M4 4h8v8H4V4z" stroke="#ff9f43" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M6 6h4M6 10h4" stroke="#4ecdc4" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="8" cy="8" r="1.5" fill="#ff6b6b"/>
              </svg>
            </div>
            <span>实时抖动</span>
            <label class="header-toggle">
              <input type="checkbox" v-model="shake.enabled"/>
              <span class="toggle-track"></span>
            </label>
          </div>
          <div class="card-body">
            <div class="time-row">
              <span>间隔</span>
              <input type="number" v-model.number="shake.intervalStart" min="1"/>
              <span>到</span>
              <input type="number" v-model.number="shake.intervalEnd" min="1"/>
              <span>秒</span>
              <select class="select" v-model="shake.mode" style="width: 90px;">
                <option value="micro">微抖动</option>
                <option value="medium">中抖动</option>
                <option value="heavy">重抖动</option>
              </select>
            </div>
          </div>
        </div>

        <!-- 实时调色 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <circle cx="4" cy="4" r="3" fill="#ff6b6b"/>
                <circle cx="12" cy="4" r="3" fill="#4ecdc4"/>
                <circle cx="4" cy="12" r="3" fill="#ffe66d"/>
                <circle cx="12" cy="12" r="3" fill="#95e1d3"/>
              </svg>
            </div>
            <span>实时调色</span>
            <label class="header-toggle">
              <input type="checkbox" v-model="colorAdjust.enabled"/>
              <span class="toggle-track"></span>
            </label>
          </div>
          <div class="card-body">
            <div class="time-row">
              <span>间隔</span>
              <input type="number" v-model.number="colorAdjust.adjustStart" min="1"/>
              <span>到</span>
              <input type="number" v-model.number="colorAdjust.adjustEnd" min="1"/>
              <span>秒</span>
              <select class="select" v-model="colorAdjust.mode" style="width: 90px;">
                <option value="micro">微调色</option>
                <option value="medium">中调色</option>
                <option value="heavy">重调色</option>
              </select>
            </div>
          </div>
        </div>

        <!-- AI智能画面重组 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M2 2l12 12M14 2L2 14" stroke="#ff6b6b" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="8" cy="8" r="3" stroke="#4ecdc4" stroke-width="1.5"/>
                <path d="M8 1v2M8 13v2M1 8h2M13 8h2" stroke="#ffe66d" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <span>AI智能画面重组</span>
            <label class="header-toggle">
              <input type="checkbox" v-model="aiRecomposition.enabled"/>
              <span class="toggle-track"></span>
            </label>
          </div>
          <div class="card-body">
            <div class="time-row">
              <span>间隔</span>
              <input type="number" v-model.number="aiRecomposition.intervalStart" min="1"/>
              <span>到</span>
              <input type="number" v-model.number="aiRecomposition.intervalEnd" min="1"/>
              <span>秒</span>
              <select class="select" v-model="aiRecomposition.mode" style="width: 90px;">
                <option value="micro">微重组</option>
                <option value="medium">中重组</option>
                <option value="heavy">重重组</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Toast 提示 -->
    <Transition name="toast">
      <div v-if="toast.show" class="toast-notification" :class="toast.type">
        <div class="toast-content">
          <svg v-if="toast.type === 'success'" width="16" height="16" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          {{ toast.message }}
        </div>
      </div>
    </Transition>

    <div class="cyber-modal-overlay" v-if="showPhoneBroadcastModal" >
      <div class="cyber-modal phone-broadcast-modal" @click.stop>
        <div class="decorative-corner top-left"></div>
        <div class="decorative-corner top-right"></div>
        <div class="decorative-corner bottom-left"></div>
        <div class="decorative-corner bottom-right"></div>

        <div class="modal-header">
          <div class="terminal-prompt">
            <span class="prompt-symbol">></span>
            <span class="prompt-text">手机转播配置</span>
          </div>
          <button class="close-button" @click="closePhoneBroadcastModal">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="4" y1="4" x2="12" y2="12"></line>
              <line x1="12" y1="4" x2="4" y2="12"></line>
            </svg>
          </button>
        </div>

        <div class="modal-body">
          <div class="phone-config-form">
            <div class="config-item">
              <span class="config-label">服务器地址</span>
              <input type="text" class="config-input" v-model="localConfig.serverUrl" placeholder="启动后自动显示" disabled>
            </div>

            <div class="config-item">
              <span class="config-label">端口</span>
              <input type="text" class="config-input" v-model="localConfig.port" placeholder="例如：8080" :disabled="localConfig.enabled">
            </div>

            <div class="config-item toggle-item">
              <span class="config-label">启用转播</span>
              <label class="cyber-switch">
                <input type="checkbox" v-model="localConfig.enabled" @change="handleEnabledChange">
                <span class="switch-track">
                <span class="switch-thumb"></span>
              </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import {delay, showToast} from "@/utils/function";
import PhoneBroadcastModal from "@/components/PhoneBroadcastModal.vue";

export default {
  name:"dashboard",
  components: {
  },
  inject: ['sendConfigToBackend','eSend','disconnectWebSocket','sendCanvasFrame','connectWebSocket','updateAllVideosAudioSinkId','setGlobalVideoSrc', 'playGlobalVideo', 'pauseGlobalVideo', 'setGlobalVideoCurrentTime', 'setGlobalVideoMuted', 'setGlobalVideoLoop', 'getGlobalVideo', 'setOverlayVideoSrc', 'playOverlayVideo', 'pauseOverlayVideo', 'getOverlayVideo', 'globalCanvasState', 'updateGlobalCanvasState', 'syncCanvasToTarget', 'startRealCamera', 'stopRealCamera', 'enumerateRealCameraDevices', 'startShake', 'stopShake', 'startColorAdjust', 'stopColorAdjust', 'startCameraMotion', 'stopCameraMotion', 'startAIRecomposition', 'stopAIRecomposition', 'setOverlayPlaylist', 'setOverlayPlayMode', 'setPlaylist', 'setPlayMode'],
  data() {

    return {
      localConfig: {
        enabled: false,
        serverUrl: '',
        port: '1935',
      },
      isPlaying:this.$store.state.currentMedia?.isPlaying,
      isLiteMode:false,
      showPhoneBroadcastModal: false,
      playbackWatchdog: null,
      audioCtx: null,
      localCameraStream: null,
      isDragging: false,
      isResizing: false,
      currentResizeHandle: '',
      dragStartX: 0,
      dragStartY: 0,
      dragStartPosX: 0,
      dragStartPosY: 0,
      resizeStartX: 0,
      resizeStartY: 0,
      resizeStartWidth: 0,
      resizeStartHeight: 0,
      resizeStartPosX: 0,
      resizeStartPosY: 0,
      
      // Canvas 同步相关
      syncCanvasFrameId: null,
      
      // 防抖定时器
      debounceTimer: null,
      
      // 防止激活时触发摄像头开关
      isActivating: false,
      
      isStarting: false,
      toast: {
        show: false,
        message: '',
        type: 'success'
      },
      audioDevices: [],
      audioSettings: {
        isMuted: false,
        driver: '',
        syncOffset: 0
      },
      material: {
        source: 'local',
        path: '',
        playMode: 'sequence',
        volume: 100
      },
      // 新增：保存初始选择的路径，用于输入框显示，播放时不会改变
      materialInitialPath: '',
      overlay: {
        source: 'local',
        path: '',
        playMode: 'sequence',
        volume: 100,
        opacity: 100
      },
      // 新增：保存遮罩视频初始选择的路径，用于输入框显示，播放时不会改变
      overlayInitialPath: '',
      overlayVideoUrl: '',
      overlayPlaylist: [],
      overlayCurrentIndex: 0,
      effectsCanvas: null,
      effectsCtx: null,
      effectsAnimationId: null,
      // 遮罩帧 Canvas
      overlayFrameCanvas: null,
      overlayFrameCtx: null,
      camera: {
        enabled: false,
        device: '',
        devices: [],
        position: {x: 20, y: 20},
        size: {width: 320, height: 240},
        zIndex: 10,
        selected: false,
        opacity: 100
      },
      // 摄像头坐标转换相关
        cameraScale: 1, // UI 到视频像素的缩放比例
        cameraOriginalRatio: 4/3, // 摄像头原始宽高比（默认4:3）


      playbackSpeed: {
        enabled: false,
        intervalStart: 5,
        intervalEnd: 10,
        mode: 'micro'
      },

      frameCapture: {
        enabled: false,
        intervalMin: 10,
        intervalMax: 20,
        frameCount: 1,
        count: 0
      },
      frameCaptureTimer: {},
      effectTimers: {}, // 效果定时器容器
      currentTime: this.$store.state.currentMedia?.currentTime ?? 0,
      duration: this.$store.state.currentMedia?.duration ?? 0,
      localIsPlaying: false, // 🔧 添加：Dashboard 本地独立的播放状态
      imageOverlayTimer: null,
      hideTimer: null,
      showControls: false,
      videoPlaylist: [],
      currentPlaylistIndex: 0,
      isPageActive: true, // 🔧 添加：页面活跃状态标记
      lastVideoUrl: '' // 🔧 添加：保存最后一次有效的视频 URL

    }

  },
  computed: {

    overlay_type(){

      return this.$store.state.overlay_play_type;
    },

    // 代理全局状态，让模板可以直接使用
    cameraSettings: {
      get() {
        return this.globalCanvasState.cameraSettings
      },
      set(val) {
        this.updateGlobalCanvasState('cameraSettings', val)
      }
    },
    effects: {
      get() {
        return this.globalCanvasState.effects
      },
      set(val) {
        this.updateGlobalCanvasState('effects', val)
      }
    },
    colorAdjust: {
      get() {
        return this.globalCanvasState.colorAdjust
      },
      set(val) {
        this.updateGlobalCanvasState('colorAdjust', val)
      }
    },
    effectsList: {
      get() {
        return this.globalCanvasState.effectsList
      }
    },
    currentEffectIndex: {
      get() {
        return this.globalCanvasState.currentEffectIndex
      },
      set(val) {
        this.updateGlobalCanvasState('currentEffectIndex', val)
      }
    },
    cameraMotion: {
      get() {
        return this.globalCanvasState.cameraMotion
      },
      set(val) {
        this.updateGlobalCanvasState('cameraMotion', val)
      }
    },
    shake: {
      get() {
        return this.globalCanvasState.shake
      },
      set(val) {
        this.updateGlobalCanvasState('shake', val)
      }
    },
    aiRecomposition: {
      get() {
        return this.globalCanvasState.aiRecomposition
      },
      set(val) {
        this.updateGlobalCanvasState('aiRecomposition', val)
      }
    },
    isCurrentlyShaking: {
      get() {
        return this.globalCanvasState.isCurrentlyShaking
      }
    },
    isVirtualCameraLive: {
      get() {
        return this.globalCanvasState.isVirtualCameraLive
      },
      set(val) {
        this.updateGlobalCanvasState('isVirtualCameraLive', val)
      }
    },
    currentAIState: {
      get() {
        return this.globalCanvasState.currentAIState
      }
    },
    aiAnimState: {
      get() {
        return this.globalCanvasState.aiAnimState
      }
    },
    colorAdjustState: {
      get() {
        return this.globalCanvasState.colorAdjustState
      }
    },
    currentCameraTransform: {
      get() {
        return this.globalCanvasState.currentCameraTransform
      }
    },
    imageOverlay: {
      get() {
        return this.globalCanvasState.imageOverlay
      },
      set(val) {
        this.updateGlobalCanvasState('imageOverlay', val)
      }
    },
    phoneBroadcast: {
      get() {
        return this.globalCanvasState.phoneBroadcast
      },
      set(val) {
        this.updateGlobalCanvasState('phoneBroadcast', val)
      }
    },

    mainVideoEffectsStyle() {
      let filter = ''
      let transform = ''
      let transitionList = []

      // AI智能画面重组 - 直接应用到主视频
      if (this.aiRecomposition.enabled) {
        const ai = this.aiAnimState.current
        transform += `scale(${ai.scale}) rotate(${ai.rotate}deg) ${this.currentAIState.value.flip ? 'scaleX(-1)' : ''} `
        filter += `brightness(${ai.brightness}) contrast(${ai.contrast}) saturate(${ai.saturation}) hue-rotate(${ai.hueRotate}deg) `
        transitionList.push('transform 2s ease-in-out', 'filter 2s ease-in-out')
      }

      // 实时调色
      if (this.colorAdjust.enabled) {
        filter += `brightness(${this.colorAdjustState.value.brightness}) contrast(${this.colorAdjustState.value.contrast}) saturate(${this.colorAdjustState.value.saturation}) hue-rotate(${this.colorAdjustState.value.hueRotate}deg) `
        if (!transitionList.includes('filter 1.5s ease-in-out')) {
          transitionList.push('filter 1.5s ease-in-out')
        }
      }

      // 实时变速通过 video 元素的 playbackRate 控制，这里不处理

      const style = {}
      if (filter.trim()) style.filter = filter.trim()
      if (transform.trim()) {
        style.transform = transform.trim()
        style.transformOrigin = 'center center'
      }
      if (transitionList.length > 0) style.transition = transitionList.join(', ')

      return style
    },
    cameraMotionStyle(){
      if (!this.cameraMotion.enabled) return {
        transform: 'scale(1) translate(0, 0)',
        transformOrigin: 'center center',
        transition: 'transform 0.5s ease-in-out'
      }
      return {
        transform: `translate(${this.currentCameraTransform.value.x}px, ${this.currentCameraTransform.value.y}px) scale(${this.currentCameraTransform.value.scale})`,
        transformOrigin: 'center center',
        transition: 'transform 8s ease-in-out' // 极长过渡实现丝滑感
      }
    },

    overlayEffectsStyle() {
      let filter = ''
      let transform = ''
      let transitionList = []

      if (this.aiRecomposition.enabled) {
        // 遮罩层保留缩放、旋转和镜像翻转，以达到最佳去重效果
        transform += `scale(${this.currentAIState.value.scale}) rotate(${this.currentAIState.value.rotate}deg) ${this.currentAIState.value.flip ? 'scaleX(-1)' : ''} `
        filter += `brightness(${this.currentAIState.value.brightness}) contrast(${this.currentAIState.value.contrast}) `
        transitionList.push('transform 2s ease-in-out', 'filter 2s ease-in-out')
      }

      const style = {}
      if (filter.trim()) style.filter = filter.trim()
      if (transform.trim()) style.transform = transform.trim()
      if (transitionList.length > 0) style.transition = transitionList.join(', ')
      
      // 添加遮罩视频的透明度
      style.opacity = this.overlay.opacity / 100
      
      return style


    },
    hotSaleConfig() {
      return this.$store.state.hotSaleParams
    },


  },
  watch: {
    '$store.state.serverUrl':{
      handler(newState) {
        console.log(newState);
        this.localConfig.serverUrl=newState
      }
    },

    // 监听全局状态变化，同步到本地
    'globalCanvasState': {
      handler(newState) {
        // 这里可以添加需要同步的逻辑，但要注意避免无限循环
      },
      deep: true
    },

    'material.volume'(newVolume) {
      this.updateVideoVolume()
    },

    'effects.enabled'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('effects', { ...this.effects, enabled: val })
      
      if (val) {
        this.initEffectsCanvas()
        // 特效现在合并到视频渲染中，不需要单独的动画
        // this.startEffectsAnimation()
        this.startEffectsSwitch()
      } else {
        // this.stopEffectsAnimation()
        this.stopEffectsSwitch()
      }

    },
    'effects.type'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('effects', { ...this.effects, type: val })
      

    },
    'effects.opacity'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('effects', { ...this.effects, opacity: val })
      

    },
    'effects.playMode'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('effects', { ...this.effects, playMode: val })
      

    },
    'overlay.playMode'(val) {
      // 同步到 App.vue 的全局状态
      this.setOverlayPlayMode(val)
      

    },
    'overlay.source'(newSource) {
      // 当切换到云存储模式时，如果已经输入了路径，自动尝试播放

      this.setOverlayPlayType(newSource)

      if (newSource === 'cloud' && this.overlayInitialPath) {
        this.playOverlayCloudVideo()
      } else if (newSource === 'local') {
        // 切换到本地模式时，可以清空当前播放或提示用户
        console.log('[云存储] 切换到本地遮罩视频模式')
      }
    },

    'material.playMode'(val) {
      // 同步到 App.vue 的全局状态
      this.setPlayMode(val)
      

    },
    'material.source'(newSource) {
      // 当切换到云存储模式时，如果已经输入了路径，自动尝试播放
      if (newSource === 'cloud' && this.materialInitialPath) {
        this.playCloudVideo()
      } else if (newSource === 'local') {
        // 切换到本地模式时，可以清空当前播放或提示用户
        console.log('[云存储] 切换到本地视频模式')
      }
    },
    // 监听直播视频当前播放索引变化 - 但不改变显示的路径
    'globalCanvasState.currentIndex'(newIndex) {
      const playlist = this.globalCanvasState.playlist
      if (playlist && playlist.length > 0 && playlist[newIndex]) {
        const video = playlist[newIndex]
        // 只更新 store，不改变 material.path（保持最初选择的路径）
        this.$store.commit('SET_CURRENT_MEDIA', {
          url: video.path || video.url || video,
          path: video.name || '',
          type: 'video'
        })
      }
    },
    // 监听遮罩视频当前播放索引变化 - 但不改变显示的路径
    'globalCanvasState.overlayCurrentIndex'(newIndex) {
      const playlist = this.globalCanvasState.overlayPlaylist
      if (playlist && playlist.length > 0 && playlist[newIndex]) {
        const video = playlist[newIndex]
        // 只更新 overlayVideoUrl，不改变 overlay.path（保持最初选择的路径）
        this.overlayVideoUrl = video.path || video.url || video
      }
    },
    'imageOverlay.enabled'(val) {
      if (val) {
        this.updateImageOverlayPreview()
      } else {
        if (this.imageOverlayTimer) {
          clearInterval(this.imageOverlayTimer)
          this.imageOverlayTimer = null
        }
        this.imageOverlay.currentImage = ''
      }
    },
    'playbackSpeed.enabled'(val) {

      val ? this.startPlaybackSpeed() : this.stopPlaybackSpeed()

    },

    'frameCapture.enabled'(val) {
      val ? this.startFrameCapture() : this.stopFrameCapture()
    },


    'cameraMotion.enabled'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('cameraMotion', { ...this.cameraMotion, enabled: val })
      
      val ? this.startCameraMotion() : this.stopCameraMotion()

    },
    'cameraMotion.mode'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('cameraMotion', { ...this.cameraMotion, mode: val })

    },
    'cameraMotion.motionStart'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('cameraMotion', { ...this.cameraMotion, motionStart: val })
      

    },
    'cameraMotion.motionEnd'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('cameraMotion', { ...this.cameraMotion, motionEnd: val })

    },
    'shake.enabled'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('shake', { ...this.shake, enabled: val })
      
      val ? this.startShake() : this.stopShake()

    },
    'shake.mode'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('shake', { ...this.shake, mode: val })

    },
    'shake.intervalStart'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('shake', { ...this.shake, intervalStart: val })
      

    },
    'shake.intervalEnd'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('shake', { ...this.shake, intervalEnd: val })

    },
    'colorAdjust.enabled'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('colorAdjust', { ...this.colorAdjust, enabled: val })
      
      val ? this.startColorAdjust() : this.stopColorAdjust()

    },
    'colorAdjust.mode'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('colorAdjust', { ...this.colorAdjust, mode: val })
      

    },
    'aiRecomposition.enabled'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('aiRecomposition', { ...this.aiRecomposition, enabled: val })
      
      val ? this.startAIRecomposition() : this.stopAIRecomposition()

    },
    'aiRecomposition.mode'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('aiRecomposition', { ...this.aiRecomposition, mode: val })
      

    },
    'aiRecomposition.intervalStart'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('aiRecomposition', { ...this.aiRecomposition, intervalStart: val })
      

    },
    'aiRecomposition.intervalEnd'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('aiRecomposition', { ...this.aiRecomposition, intervalEnd: val })
      

    },
    'camera.enabled'(val) {
      // 如果正在激活页面，跳过处理
      if (this.isActivating) {
        return
      }
      
      // 同步到全局状态
      this.updateGlobalCanvasState('realCamera', { 
        ...this.camera, 
        enabled: val 
      })
      
      if (val) {
        // 先确保有设备列表
        if (this.camera.devices.length === 0) {
          this.enumerateCameraDevices()
        }
        this.startCamera()
      } else {
        this.stopCamera()
      }
    },
    'camera.device'(val) {
      if (this.camera.enabled && val) {
        this.stopCamera()
        this.startCamera()
      }
    },
    'camera.position.x'(val) {
      // 如果正在拖动或调整大小，跳过，因为已经在拖动方法中处理了
      if (this.isDragging || this.isResizing) return
      
      // 同步到全局状态
      const videoCoords = this.uiToVideoCoords(
        val, 
        this.camera.position.y, 
        this.camera.size.width, 
        this.camera.size.height
      )
      this.updateGlobalCanvasState('realCamera', {
        ...this.camera,
        position: { x: videoCoords.x, y: videoCoords.y },
        size: { width: videoCoords.width, height: videoCoords.height }
      })
      

    },
    'camera.position.y'(val) {
      // 如果正在拖动或调整大小，跳过
      if (this.isDragging || this.isResizing) return
      
      // 同步到全局状态
      const videoCoords = this.uiToVideoCoords(
        this.camera.position.x, 
        val, 
        this.camera.size.width, 
        this.camera.size.height
      )
      this.updateGlobalCanvasState('realCamera', {
        ...this.camera,
        position: { x: videoCoords.x, y: videoCoords.y },
        size: { width: videoCoords.width, height: videoCoords.height }
      })
      

    },
    'camera.size.width'(val) {
      // 如果正在拖动或调整大小，跳过
      if (this.isDragging || this.isResizing) return
      
      // 同步到全局状态
      const videoCoords = this.uiToVideoCoords(
        this.camera.position.x, 
        this.camera.position.y, 
        val, 
        this.camera.size.height
      )
      this.updateGlobalCanvasState('realCamera', {
        ...this.camera,
        position: { x: videoCoords.x, y: videoCoords.y },
        size: { width: videoCoords.width, height: videoCoords.height }
      })
      

    },
    'camera.size.height'(val) {
      // 如果正在拖动或调整大小，跳过
      if (this.isDragging || this.isResizing) return
      
      // 同步到全局状态
      const videoCoords = this.uiToVideoCoords(
        this.camera.position.x, 
        this.camera.position.y, 
        this.camera.size.width, 
        val
      )
      this.updateGlobalCanvasState('realCamera', {
        ...this.camera,
        position: { x: videoCoords.x, y: videoCoords.y },
        size: { width: videoCoords.width, height: videoCoords.height }
      })
      

    },

    'overlay.opacity'(val) {
      // 同步到全局状态
      this.updateGlobalCanvasState('overlay', { ...this.overlay, opacity: val })
   
    },
    // 摄像头透明度变化
    'camera.opacity'(newOpacity) {
      console.log('摄像头透明度变化：', newOpacity); // 调试日志
      this.updateGlobalCanvasState('realCamera', {
        ...this.globalCanvasState.realCamera,
        opacity: newOpacity
      })
    },
    // 'imageOverlay.enabled'(val) {
    //   if (val) {
    //     this.updateImageOverlayPreview()
    //   } else {
    //     if (this.imageOverlayTimer) {
    //       clearInterval(this.imageOverlayTimer)
    //       this.imageOverlayTimer = null
    //     }
    //     this.imageOverlay.currentImage = ''
    //   }
    //   this.sendOverlaySettingsDebounced()
    // },


    // 'cameraMotion.mode'(val){
    //   if (this.cameraMotion.enabled) {
    //     this.applyCameraMotion()
    //   }
    // },
    //
    // 'cameraMotion.motionStart'(){
    //   if (this.cameraMotion.enabled) {
    //     this.applyCameraMotion()
    //   }
    // },
    // 'cameraMotion.motionEnd'(){
    //   if (this.cameraMotion.enabled) {
    //     this.applyCameraMotion()
    //   }
    // },

    // 实时切换音频输出设备
    'audioSettings.driver'(newDeviceId) {
      this.changeAudioOutput(newDeviceId);
      this.updateGlobalCanvasState('audioSettings', { ...this.audioSettings, driver: newDeviceId });
    },
    // 遮罩视频音量变化
    'overlay.volume'(newVolume) {
      const overlayVideo = this.getOverlayVideo()
      if (overlayVideo) {
        overlayVideo.volume = newVolume / 100
        overlayVideo.muted = newVolume === 0
      }
    },


  },
  mounted() {

    window.resetAllFunctions=this.resetAllFunctions;
    // 初始化时设置一个示例视频，方便测试

    // 确保视频加载后音量设置正确
    this.$nextTick(() => {
      this.updateVideoVolume()
      this.initEffectsCanvas()
      this.setupGlobalVideoListeners()
      // 初始化音频输出设备
      if (this.audioSettings.driver) {
        this.updateAllVideosAudioSinkId(this.audioSettings.driver);

      }
    })
    
    // 初始化时获取摄像头设备列表
    this.enumerateCameraDevices()
    
    // 初始化时获取音频设备列表
    this.enumerateAudioDevices()

    // 监听全局点击，点击其他地方取消选中
    document.addEventListener('click', this.handleDocumentClick)

    console.log('[Dashboard] 页面已激活，从 store 恢复播放状态')
     if (this.globalCanvasState.realCameraDevices && this.globalCanvasState.realCameraDevices.length > 0) {
       this.camera.devices = this.globalCanvasState.realCameraDevices
     }
     // 从全局状态初始化摄像头透明度
     if (this.globalCanvasState.realCamera && this.globalCanvasState.realCamera.opacity !== undefined) {
       this.camera.opacity = this.globalCanvasState.realCamera.opacity
       console.log('从全局状态初始化摄像头透明度：', this.globalCanvasState.realCamera.opacity); // 调试日志
     } else {
       console.log('全局状态中没有找到 realCamera.opacity，使用默认值 100'); // 调试日志
     }
     this.startCanvasSync()

  /*  this.isPageActive = true
    this.isActivating = true // 设置激活标志

    // 设置真实摄像头视频元素引用
    this.$nextTick(() => {
      // 先计算缩放比例
      this.calculateCameraScale()
      // 确保 cameraScale 有有效值
      if (!this.cameraScale || this.cameraScale <= 0) {
        this.cameraScale = 1 // 默认比例
      }

      // 如果全局状态中有摄像头数据，转换回 UI 坐标
      if (this.globalCanvasState.realCamera) {
        const globalCam = this.globalCanvasState.realCamera
        // 检查全局坐标是否有效
        const hasValidGlobalCoords = globalCam.position &&
            typeof globalCam.position.x === 'number' &&
            !isNaN(globalCam.position.x) &&
            globalCam.size &&
            typeof globalCam.size.width === 'number' &&
            !isNaN(globalCam.size.width) &&
            globalCam.size.width > 0

        if (hasValidGlobalCoords) {
          const uiCoords = this.videoToUiCoords(
              globalCam.position.x,
              globalCam.position.y,
              globalCam.size.width,
              globalCam.size.height
          )
          // 只更新位置和大小，保持其他状态
          this.camera.position.x = uiCoords.x
          this.camera.position.y = uiCoords.y
          this.camera.size.width = uiCoords.width
          this.camera.size.height = uiCoords.height
        }
        // 只在全局状态明确是 false 时才禁用，否则保持原状态
        if (globalCam.enabled !== undefined) {
          this.camera.enabled = globalCam.enabled
        }
      }

      // 如果已经有流，确保 Dashboard 的视频元素也有
      if (this.globalCanvasState.realCameraStream) {
        if (this.$refs.localCameraVideo) {
          this.$refs.localCameraVideo.srcObject = this.globalCanvasState.realCameraStream
          // 确保视频在 Dashboard 中也播放
          this.$refs.localCameraVideo.play().catch(e => console.log('Dashboard 摄像头播放失败:', e))
        }
        if (this.$refs.cameraVideoElement) {
          this.$refs.cameraVideoElement.srcObject = this.globalCanvasState.realCameraStream
          this.$refs.cameraVideoElement.play().catch(e => console.log('Dashboard 摄像头备用播放失败:', e))
        }
      }

      // 同步摄像头设备列表
      if (this.globalCanvasState.realCameraDevices && this.globalCanvasState.realCameraDevices.length > 0) {
        this.camera.devices = this.globalCanvasState.realCameraDevices
      }

      // 延迟一点清除标志，给 watch 一点时间
      setTimeout(() => {
        this.isActivating = false
      }, 50)
    })

    // 开始同步 canvas 画面
    this.startCanvasSync()


    // 🔧 优先从 store 中读取播放状态
    const storeMedia = this.$store.state.currentMedia
    if (storeMedia) {
      console.log('[Dashboard] 从 store 读取播放状态:', {
        isPlaying: storeMedia.isPlaying,
        currentTime: storeMedia.currentTime,
        duration: storeMedia.duration
      })

      // 同步 store 的状态到本地
      this.currentTime = storeMedia.currentTime || 0
      this.duration = storeMedia.duration || 0
      this.isPlaying = storeMedia.isPlaying || false
      this.localIsPlaying = storeMedia.isPlaying || false
    }



    // 🔧 然后检查视频元素的实际状态
    const globalVideo = this.getGlobalVideo()
    if (globalVideo) {
      const actualIsPlaying = !globalVideo.paused && !globalVideo.ended
      console.log('[Dashboard] 视频实际播放状态:', actualIsPlaying)

      // 🔧 关键：如果 store 中显示应该播放，但视频没播放，尝试恢复播放
      if (!actualIsPlaying && this.isPlaying) {
        console.log('[Dashboard] Store 显示应该播放，尝试恢复视频播放')

        // 如果当前时间与 store 不一致，先跳转到正确位置
        if (storeMedia && storeMedia.currentTime !== undefined &&
            Math.abs(globalVideo.currentTime - storeMedia.currentTime) > 1) {
          this.setGlobalVideoCurrentTime(storeMedia.currentTime)
        }

        this.$nextTick(() => {
          this.playGlobalVideo()
        })
      } else if (actualIsPlaying) {
        // 如果视频正在播放，保持它并同步 store
        console.log('[Dashboard] 视频已经在播放，保持当前状态')
        this.isPlaying = true
        this.localIsPlaying = true
        this.syncVideoStateToStore()
      }

      this.startPlaybackWatchdog()
    }
    // 初始化音频输出设备
    if (this.audioSettings.driver) {
      this.updateAllVideosAudioSinkId(this.audioSettings.driver);
    }*/
  },
  beforeDestroy() {
    // 移除全局点击监听
    document.removeEventListener('click', this.handleDocumentClick)
    this.stopEffectsAnimation()
    this.stopEffectsSwitch()
    // 注意：不停止视频渲染，让 App.vue 继续处理
    //this.removeGlobalVideoListeners()
    if (this.imageOverlayTimer) {
      clearInterval(this.imageOverlayTimer)
      this.imageOverlayTimer = null
    }
  },
  methods: {

    setOverlayPlayType(type){

      this.$store.commit("setOverlayPlayType",type)

    },

    // 计算摄像头坐标缩放比例
    calculateCameraScale() {
      this.cameraScale = 1 // 默认比例，保证至少有一个值
      const videoPreview = document.querySelector('.video-preview')
      const videoCanvas = this.$refs.videoCanvas
      
      if (videoPreview && videoCanvas && videoCanvas.width > 0) {
        // 获取 video-element 的实际显示尺寸
        const videoElement = document.querySelector('.video-element')
        if (videoElement) {
          const elementRect = videoElement.getBoundingClientRect()
          if (elementRect.width > 0) {
            // 计算缩放比例：视频像素 / UI 像素
            this.cameraScale = videoCanvas.width / elementRect.width
          }
        } else {
          const previewRect = videoPreview.getBoundingClientRect()
          if (previewRect.width > 0) {
            this.cameraScale = videoCanvas.width / previewRect.width
          }
        }
      }
      console.log('[Camera Scale] 计算的缩放比例:', this.cameraScale)
    },
    
    // 将 UI 坐标转换为视频像素坐标
    uiToVideoCoords(uiX, uiY, uiWidth, uiHeight) {
      this.calculateCameraScale()
      return {
        x: uiX * this.cameraScale,
        y: uiY * this.cameraScale,
        width: uiWidth * this.cameraScale,
        height: uiHeight * this.cameraScale
      }
    },
    
    // 将视频像素坐标转换为 UI 坐标
    videoToUiCoords(videoX, videoY, videoWidth, videoHeight) {
      this.calculateCameraScale()
      const scale = this.cameraScale > 0 ? this.cameraScale : 1
      return {
        x: videoX / scale,
        y: videoY / scale,
        width: videoWidth / scale,
        height: videoHeight / scale
      }
    },
    
    // 开始同步 canvas 画面
    startCanvasSync() {
      if (this.syncCanvasFrameId) {
        cancelAnimationFrame(this.syncCanvasFrameId)
      }

      const sync = () => {
        const videoCanvas = this.$refs.videoCanvas
        if (videoCanvas) {
          this.syncCanvasToTarget(videoCanvas)
        }
        this.syncCanvasFrameId = requestAnimationFrame(sync)
      }

      sync()
    },

    // 停止同步 canvas 画面
    stopCanvasSync() {
      if (this.syncCanvasFrameId) {
        cancelAnimationFrame(this.syncCanvasFrameId)
        this.syncCanvasFrameId = null
      }
    },

    // 实时切换音频输出设备
    async changeAudioOutput(deviceId) {
      this.updateAllVideosAudioSinkId(deviceId);

    },

    // 设置全局视频事件监听
    async setupGlobalVideoListeners() {

      await delay(300);

      const globalVideo = this.getGlobalVideo()


      if (!globalVideo) return
      
      // 添加事件监听器
      globalVideo.addEventListener('timeupdate', this.updateProgress)
      globalVideo.addEventListener('seeked', this.onVideoSeeked)
      globalVideo.addEventListener('loadedmetadata', this.onVideoLoaded)
      globalVideo.addEventListener('ended', this.onVideoEnded)
      globalVideo.addEventListener('error', this.handleVideoError)
      globalVideo.addEventListener('play', this.onVideoPlay)
      globalVideo.addEventListener('pause', this.onVideoPause)
    },
    
    // 移除全局视频事件监听
    removeGlobalVideoListeners() {
      const globalVideo = this.getGlobalVideo()
      if (!globalVideo) return
      
      globalVideo.removeEventListener('timeupdate', this.updateProgress)
      globalVideo.removeEventListener('seeked', this.onVideoSeeked)
      globalVideo.removeEventListener('loadedmetadata', this.onVideoLoaded)
      globalVideo.removeEventListener('ended', this.onVideoEnded)
      globalVideo.removeEventListener('error', this.handleVideoError)
      globalVideo.removeEventListener('play', this.onVideoPlay)
      globalVideo.removeEventListener('pause', this.onVideoPause)

      // 移除我们新添加的监听器
      if (this._globalVideoLoadedHandler) {
        globalVideo.removeEventListener('loadeddata', this._globalVideoLoadedHandler)
        this._globalVideoLoadedHandler = null
      }
      if (this._globalVideoErrorHandler) {
        globalVideo.removeEventListener('error', this._globalVideoErrorHandler)
        this._globalVideoErrorHandler = null
      }
    },

    
    // 开始视频渲染
    startVideoRender() {
      if (this.videoRenderFrameId) {
        cancelAnimationFrame(this.videoRenderFrameId)
      }
      
      const render = () => {
        const globalVideo = this.getGlobalVideo()
        // console.log('[render loop] 运行! videoCtx:', !!this.videoCtx, 'videoCanvas:', !!this.videoCanvas, 'isVirtualCameraLive:', this.isVirtualCameraLive)
        //
        // 只要有 canvas 上下文就渲染，这样即使视频没在播放也能发送帧
        if (this.videoCtx && this.videoCanvas) {
          // 使用视频的原始分辨率作为 canvas 的实际分辨率，保持原画质
          let targetWidth = 1280
          let targetHeight = 720
          
          if (globalVideo && globalVideo.videoWidth > 0 && globalVideo.videoHeight > 0) {
            targetWidth = globalVideo.videoWidth
            targetHeight = globalVideo.videoHeight
          }
          
          if (this.videoCanvas.width !== targetWidth || 
              this.videoCanvas.height !== targetHeight) {
            this.videoCanvas.width = targetWidth
            this.videoCanvas.height = targetHeight
            
            // 设置图像平滑模式为高质量
            this.videoCtx.imageSmoothingEnabled = true
            this.videoCtx.imageSmoothingQuality = 'high'
            
            console.log('[Canvas] 设置尺寸为:', targetWidth, 'x', targetHeight)
          }
          
          // 1. 先清除画布（填充为黑色，避免空画布）
          this.videoCtx.fillStyle = '#000000'
          this.videoCtx.fillRect(0, 0, this.videoCanvas.width, this.videoCanvas.height)
          
          // 2. 直接从 App.vue 的 globalCanvas 同步，所有特效都由 App.vue 处理
          this.syncCanvasToTarget(this.videoCanvas)
          
          // 不再需要在这里应用任何特效，都由 App.vue 统一处理
          
          // 清除滤镜
          this.videoCtx.filter = 'none'
          
          // 6. 如果特效启用，渲染特效到同一个画布
          if (this.effects.enabled) {
            this.effectsTime++
            this.drawEffectsToVideoCanvas()
          }
          
          // 6. 通过 WebSocket 发送 Canvas 帧
          console.log('[render loop] isVirtualCameraLive:', this.isVirtualCameraLive)
          if (this.isVirtualCameraLive) {
            this.sendCanvasFrame()
          }
        }
        
        this.videoRenderFrameId = requestAnimationFrame(render)
      }
      
      render()
    },



    
    // 发送 Canvas 帧到后端 - WebSocket 版本，更快更实时

    // 将特效渲染到视频画布
    drawEffectsToVideoCanvas() {
      if (!this.videoCanvas || !this.videoCtx) return
      
      const ctx = this.videoCtx
      const w = this.videoCanvas.width
      const h = this.videoCanvas.height
      
      // 保存当前状态（为了恢复透明度）
      ctx.save()
      ctx.globalAlpha = this.effects.opacity / 100
      
      // 特效切换时重置粒子数组
      if (this.lastEffectType !== this.effects.type) {
        this.effectsParticles = []
        this.lastEffectType = this.effects.type
      }
      
      switch(this.effects.type) {
        case '字幕雨':
          this.drawTextRain(ctx, w, h)
          break
        case '雪花':
          this.drawSnow(ctx, w, h)
          break
        case '星空':
          this.drawStarfield(ctx, w, h)
          break
        case '动态杂点':
          this.drawNoise(ctx, w, h)
          break
        case '粒子线条':
          this.drawParticleLines(ctx, w, h)
          break
        case '彩色光斑':
          this.drawColorBokeh(ctx, w, h)
          break
        case '动态扫描线':
          this.drawScanlines(ctx, w, h)
          break
        case '混沌透视重塑':
          this.drawChaos(ctx, w, h)
          break

        case '色彩偏移':
          this.drawColorShift(ctx, w, h)
          break
        case '边缘流光':
          this.drawEdgeGlow(ctx, w, h)
          break
        case 'AI像素重组':
          this.drawPixelRecombine(ctx, w, h)
          break
      }
      
      // 恢复状态
      ctx.restore()
    },
    

    

    handleDocumentClick(e) {
      // 检查点击是否在摄像头区域内
      const cameraContainer = this.$el.querySelector('.camera-container')
      if (cameraContainer && !cameraContainer.contains(e.target)) {
        // 不在摄像头区域内，取消选中
        this.camera.selected = false
      }
    },

    createSafeBlobUrl(file) {
      const url = URL.createObjectURL(file)
      return url
    },
    processImageFiles(files) {
      const imageOverlay = this.imageOverlay;
      imageOverlay.images = []

      // 筛选图片文件
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp']
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const fileName = file.name.toLowerCase()
        if (imageExtensions.some(ext => fileName.endsWith(ext))) {
          imageOverlay.images.push({
            url: this.createSafeBlobUrl(file),
            name: file.name
          })
        }
      }

      if (imageOverlay.images.length > 0) {
        imageOverlay.currentIndex = 0
        imageOverlay.currentImage = imageOverlay.images[0].url
      }

      // 设置路径
      const file = files[0]
      if (file) {
        const fullPath = file.path
        if (fullPath) {
          imageOverlay.path = fullPath.substring(0, fullPath.lastIndexOf(file.name) - 1).replace(/\\/g, '/')
        } else {
          const path = file.webkitRelativePath || file.name || ''
          const folderPath = path.split('/')[0]
          imageOverlay.path = folderPath
          showToast('浏览器安全限制：请手动粘贴完整路径', 'warning')
        }
      }

      // 如果有图片，开始播放
      if (imageOverlay.images.length > 0) {
        this.startImagePlayback()
      }
    },
    startImagePlayback() {
      this.updateImageOverlayPreview()
    },
    async updateImageOverlayPreview() {
      // 无论驱动是否开启，前端都保持显示预览
      const imageOverlay = this.imageOverlay;
      const imageOverlayTimer = this.imageOverlayTimer;
      if (!imageOverlay.enabled || !imageOverlay.images.length) {
        imageOverlay.currentImage = ''
        if (imageOverlayTimer) {
          clearInterval(imageOverlayTimer)
          this.imageOverlayTimer = null
        }
        return
      }

      // 使用本地已加载的图片，不再调用后端接口
      let lastIndex = -1

      const nextImg = () => {
        if (!imageOverlay.images.length) return
        
        let newIndex
        if (imageOverlay.images.length === 1) {
          newIndex = 0
        } else {
          // 随机选择一个不同的图片
          do {
            newIndex = Math.floor(Math.random() * imageOverlay.images.length)
          } while (newIndex === lastIndex)
        }
        lastIndex = newIndex
        
        const imgData = imageOverlay.images[newIndex]
        imageOverlay.currentIndex = newIndex
        
        // 使用本地 blob URL
        imageOverlay.currentImage = imgData.url || imgData
        

      }

      if (imageOverlayTimer) clearInterval(imageOverlayTimer)
      nextImg()
      this.imageOverlayTimer = setInterval(nextImg, 5000)
    },


    handleDrop(event, type = '') {
      const files = event.dataTransfer?.files
      if (!files || files.length === 0) return

      const material = this.material;
      const store = this.$store;
      const isPlaying = this.isPlaying;
      const isVirtualCameraLive = this.isVirtualCameraLive;
      const file = files[0]
      const fullPath = file.path
      const cleanPath = (fullPath || file.name).replace(/\\/g, '/')

      if (type === 'material') {
        material.path = cleanPath
        store.commit('SET_CURRENT_MEDIA', {
          url: this.createSafeBlobUrl(file),
          path: cleanPath,
          type: 'video'
        })
        this.isPlaying = false
        this.localIsPlaying = false


        if (!fullPath) showToast('浏览器安全限制：请手动粘贴完整路径', 'warning')
      } else if (type === 'overlay') {
        this.overlay.path = cleanPath
        this.overlayVideoUrl = this.createSafeBlobUrl(file)
        if (!fullPath) showToast('浏览器安全限制：请手动粘贴完整路径', 'warning')
      } else if (type === 'imageOverlay') {
        // 如果是图片遮罩，处理整个拖入的文件列表
        this.processImageFiles(files)
      }
    },


    handleCameraMouseDown(e) {
      e.stopPropagation()

      this.camera.selected = true
      this.isDragging = true
      this.dragStartX = e.clientX
      this.dragStartY = e.clientY
      this.dragStartPosX = this.camera.position.x
      this.dragStartPosY = this.camera.position.y

      document.addEventListener('mousemove', this.handleCameraMouseMove)
      document.addEventListener('mouseup', this.handleCameraMouseUp)
    },
    handleCameraMouseMove(e) {
      if (this.isDragging) {
        const dx = e.clientX - this.dragStartX
        const dy = e.clientY - this.dragStartY
        this.camera.position.x = this.dragStartPosX + dx
        this.camera.position.y = this.dragStartPosY + dy
        // 转换坐标并实时同步到全局状态
        const videoCoords = this.uiToVideoCoords(
          this.camera.position.x, 
          this.camera.position.y, 
          this.camera.size.width, 
          this.camera.size.height
        )
        this.updateGlobalCanvasState('realCamera', {
          ...this.camera,
          position: { x: videoCoords.x, y: videoCoords.y },
          size: { width: videoCoords.width, height: videoCoords.height }
        })
      }
    },
    handleCameraMouseUp() {
      this.isDragging = false
      document.removeEventListener('mousemove', this.handleCameraMouseMove)
      document.removeEventListener('mouseup', this.handleCameraMouseUp)
    },

    handleResizeStart(e, handle) {
      e.stopPropagation()
      e.preventDefault()
      this.camera.selected = true
      this.isResizing = true
      this.currentResizeHandle = handle
      this.resizeStartX = e.clientX
      this.resizeStartY = e.clientY
      this.resizeStartWidth = this.camera.size.width
      this.resizeStartHeight = this.camera.size.height
      this.resizeStartPosX = this.camera.position.x
      this.resizeStartPosY = this.camera.position.y
      document.addEventListener('mousemove', this.handleResizeMove)
      document.addEventListener('mouseup', this.handleResizeMouseUp)
    },
    handleResizeMouseUp() {
      this.isResizing = false
      document.removeEventListener('mousemove', this.handleResizeMove)
      document.removeEventListener('mouseup', this.handleResizeMouseUp)
    },
    handleResizeMove(e) {
      const resizeStartX = this.resizeStartX;
      const isResizing = this.isResizing;
      const resizeStartY = this.resizeStartY;
      const resizeStartWidth = this.resizeStartWidth;
      const resizeStartHeight = this.resizeStartHeight;
      const resizeStartPosX = this.resizeStartPosX;
      const currentResizeHandle = this.currentResizeHandle;
      const resizeStartPosY = this.resizeStartPosY;
      const camera = this.camera;
      if (!isResizing) return

      const dx = e.clientX - resizeStartX
      const dy = e.clientY - resizeStartY
      const minSize = 50 // 最小 UI 尺寸

      switch (currentResizeHandle) {
        case 'br':
          // 右下角：只调整宽度和高度
          camera.size.width = Math.max(minSize, resizeStartWidth + dx)
          camera.size.height = Math.max(minSize, resizeStartHeight + dy)
          break
        case 'tl':
          // 左上角：调整位置和大小
          camera.position.x = resizeStartPosX + dx
          camera.position.y = resizeStartPosY + dy
          camera.size.width = Math.max(minSize, resizeStartWidth - dx)
          camera.size.height = Math.max(minSize, resizeStartHeight - dy)
          break
        case 'tr':
          // 右上角：调整Y位置、高度，调整宽度
          camera.position.y = resizeStartPosY + dy
          camera.size.width = Math.max(minSize, resizeStartWidth + dx)
          camera.size.height = Math.max(minSize, resizeStartHeight - dy)
          break
        case 'bl':
          // 左下角：调整X位置、宽度，调整高度
          camera.position.x = resizeStartPosX + dx
          camera.size.width = Math.max(minSize, resizeStartWidth - dx)
          camera.size.height = Math.max(minSize, resizeStartHeight + dy)
          break
      }
      // 转换坐标并实时同步到全局状态
      const videoCoords = this.uiToVideoCoords(
        this.camera.position.x, 
        this.camera.position.y, 
        this.camera.size.width, 
        this.camera.size.height
      )
      this.updateGlobalCanvasState('realCamera', {
        ...this.camera,
        position: { x: videoCoords.x, y: videoCoords.y },
        size: { width: videoCoords.width, height: videoCoords.height }
      })
    },


    handleVideoError(e) {
      const video = e.target
      if (!video.error) return
      // 屏蔽常见的“中止”和“空资源”错误
      const isAbort = video.error.code === 4 || video.error.message?.includes('ABORT')
      if (isAbort) return
      console.error('[播放器] 视频加载失败:', {
        src: video.src,
        code: video.error?.code,
        message: video.error?.message
      })
      
      // 对解码错误给出友好提示
      if (video.error.code === 3) {
        showToast('视频解码失败，可能视频文件损坏或编码格式不支持', 'error')
      }
      
      // 尝试自动修复 127.0.0.1 vs localhost 的地址冲突
      if (video.src.includes('127.0.0.1') && window.location.hostname === 'localhost') {
        const newSrc = video.src.replace('127.0.0.1', 'localhost')
        console.log('[播放器] 尝试修复地址并重试:', newSrc)
        video.src = newSrc
        return
      }

      if (video.src.includes('localhost') && window.location.hostname === '127.0.0.1') {
        const newSrc = video.src.replace('localhost', '127.0.0.1')
        console.log('[播放器] 尝试修复地址并重试:', newSrc)
        video.src = newSrc
        return
      }

    },




    async applyCameraSettings() {
      if (!this.cameraSettings.name) {
        showToast('请输入摄像头名称', 'error')
        return
      }

      // 如果正在运行，点击则是停止
      if (this.isVirtualCameraLive) {
        // 1. 瞬时切换 UI 状态，给予用户即时反馈
        this.isVirtualCameraLive = false
        
        // 更新全局状态，让 App.vue 处理停止逻辑
        this.updateGlobalCanvasState('isVirtualCameraLive', false)
        
        this.resetAllFunctions() // 停止驱动时同时关闭所有功能

        // 停止本地播放
        const globalVideo = this.getGlobalVideo()
        if (globalVideo) this.pauseGlobalVideo()
        this.isPlaying = false
        this.localIsPlaying = false

        // 断开 WebSocket 连接
        console.log('[驱动] 正在断开 WebSocket 连接...')
        const result = await this.sendConfigToBackend('stop')
        if(result){
          showToast(`虚拟摄像头驱动 "${this.cameraSettings.name}" 已卸载并关闭所有功能`, 'success')

        }else{
          showToast('停止指令发送失败，但本地状态已重置', 'warning')

        }

        return
      }
      this.eSend("start",this.$store.state.token);

/*      // 启动前先检查是否有视频
      if (!this.material.path) {
        showToast('请先选择一个视频文件', 'error')
        return
      }*/
      // 启动逻辑
      this.isStarting = true

      // 1. 核心修复：启动前保持当前进度，不强制归零
      console.log('[驱动] 准备启动驱动，正在同步当前播放进度...');
      const globalVideo = this.getGlobalVideo()
      const startPos = globalVideo ? globalVideo.currentTime : 0;
      const wasPlaying = globalVideo ? !globalVideo.paused : false;

      // 关键修复：启动驱动时不要暂停视频
      // if (videoPlayer) {
      //   videoPlayer.pause()
      // }

      // 初始指令同步当前位置，不再重置为 0

      // 连接 WebSocket
      console.log('[驱动] 正在连接 WebSocket...')
      const result = await this.sendConfigToBackend('start')

      if (result === true) { // 成功
        // 更新全局状态，让 App.vue 处理启动逻辑
        this.updateGlobalCanvasState('isVirtualCameraLive', true)
        this.updateGlobalCanvasState('streamTimestamp', Date.now())

        // 在轻量级预览模式下，响应要更快
        const waitTime = this.isLiteMode || 0

        console.log('[驱动] 驱动已就绪');

        // 先确保视频处于暂停状态，等待驱动完全启动
        if (globalVideo) {
          this.pauseGlobalVideo()
        }

        setTimeout(() => {
          this.isStarting = false
          // 核心优化：启动成功后保持之前的播放状态
          if (globalVideo) {
            this.isPlaying = wasPlaying
            this.localIsPlaying = wasPlaying
            // 驱动启动完成后，重新同步进度
            if (globalVideo.currentTime !== startPos) {
              this.setGlobalVideoCurrentTime(startPos)
              console.log('[同步] 重新同步视频进度到:', startPos)
            }
            // 确保视频按照之前的状态播放
            if (wasPlaying && globalVideo.paused) {
              this.playGlobalVideo()
            } else if (!wasPlaying && !globalVideo.paused) {
              this.pauseGlobalVideo()
            }
          }

          // 关键修复：驱动完全启动后，再发送一次完整的更新配置，确保遮罩特效被正确推送！
          console.log('[同步] 发送完整更新配置到后端...');


          showToast(this.isLiteMode ? '预览模式已激活' : '驱动已就绪', 'success')
        }, waitTime);
      } else {
        this.isStarting = false
        const msg = typeof result === 'string' ? result : '无法连接到服务器';
         showToast(`启动驱动失败：${msg}`, 'error')
      }
    },
    openPhoneBroadcast() {

      if(this.isVirtualCameraLive){
        this.showPhoneBroadcastModal = true;

      }else{
        showToast(`请先启动驱动`, 'error')

      }
    },
    closePhoneBroadcastModal() {
      this.showPhoneBroadcastModal = false;
    },



    resetAllFunctions() {
      this.stopPlaybackWatchdog()
      this.pauseOverlayVideo()
      this.updateGlobalCanvasState('isVirtualCameraLive', false)
      // 停止去重相关特效，但保留遮罩特效、图片遮罩和遮罩视频
      this.updateGlobalCanvasState('colorAdjust', { ...this.colorAdjust, enabled: false })
      this.playbackSpeed.enabled = false
      this.frameCapture.enabled = false
      this.updateGlobalCanvasState('cameraMotion', { ...this.cameraMotion, enabled: false })
      this.updateGlobalCanvasState('shake', { ...this.shake, enabled: false })
      this.updateGlobalCanvasState('aiRecomposition', { ...this.aiRecomposition, enabled: false })
      this.disconnectWebSocket();
      this.pauseGlobalVideo();
      this.eSend("stop");


      // 注意：不重置 effects.enabled、imageOverlay.enabled 和 overlay，让用户可以继续看到遮罩效果
    },
    formatTime(seconds) {
      if (!isFinite(seconds)) return '00:00'
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    },

    async enumerateCameraDevices() {
      try {
        const devices = await this.enumerateRealCameraDevices()
        this.camera.devices = devices
        
        if (this.camera.devices.length > 0 && !this.camera.device) {
          this.camera.device = this.camera.devices[0].deviceId
        }
        
        showToast(`已找到 ${this.camera.devices.length} 个摄像头`, 'success')
      } catch (error) {
        console.error('获取摄像头设备失败:', error)
        showToast('无法访问摄像头，请检查权限设置', 'error')
      }
    },
    async enumerateAudioDevices() {
      try {
        // 先获取设备列表
        let devices = await navigator.mediaDevices.enumerateDevices()
        let audioOutputDevices = devices.filter(device => device.kind === 'audiooutput')

        // 如果没有设备标签，尝试获取音频权限后再次枚举
        const hasEmptyLabels = audioOutputDevices.some(device => !device.label)
        if (hasEmptyLabels) {
          try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
            stream.getTracks().forEach(track => track.stop())
            // 再次枚举设备获取标签
            devices = await navigator.mediaDevices.enumerateDevices()
            audioOutputDevices = devices.filter(device => device.kind === 'audiooutput')
          } catch (permError) {
            console.log('无法获取音频权限，将显示无标签的设备')
          }
        }
        
        // 更新设备列表
        this.audioDevices = audioOutputDevices
        
        // 如果找到设备且没有选中的驱动，选择第一个
        if (this.audioDevices.length > 0 && !this.audioSettings.driver) {
          this.audioSettings.driver = this.audioDevices[0].deviceId
        }
        
        showToast(`已找到 ${this.audioDevices.length} 个音频设备`, 'success')
        console.log('音频设备列表:', this.audioDevices)
      } catch (error) {
        console.error('获取音频设备失败:', error)
        showToast('无法访问音频设备，请检查权限设置', 'error')
      }
    },

    
    async startCamera() {
      try {
        await this.startRealCamera(this.camera.device)
        
        // 同时更新 Dashboard 的 video 元素，以便 UI 显示
        if (this.globalCanvasState.realCameraStream) {
          if (this.$refs.localCameraVideo) {
            this.$refs.localCameraVideo.srcObject = this.globalCanvasState.realCameraStream
            // 确保视频在 Dashboard 中也播放
            this.$refs.localCameraVideo.play().catch(e => console.log('Dashboard 摄像头播放失败:', e))
            
            // 监听原始宽高
            this.$refs.localCameraVideo.onloadedmetadata = () => {
              if (this.$refs.localCameraVideo) {
                const videoW = this.$refs.localCameraVideo.videoWidth
                const videoH = this.$refs.localCameraVideo.videoHeight
                if (videoW > 0 && videoH > 0) {
                  this.cameraOriginalRatio = videoW / videoH
                  console.log('[Dashboard Camera] 原始宽高比:', this.cameraOriginalRatio)
                }
              }
            }
          }
          if (this.$refs.cameraVideoElement) {
            this.$refs.cameraVideoElement.srcObject = this.globalCanvasState.realCameraStream
            this.$refs.cameraVideoElement.play().catch(e => console.log('Dashboard 摄像头备用播放失败:', e))
          }
        }
        
        // 转换坐标并同步到全局状态
        const videoCoords = this.uiToVideoCoords(
          this.camera.position.x, 
          this.camera.position.y, 
          this.camera.size.width, 
          this.camera.size.height
        )
        this.updateGlobalCanvasState('realCamera', {
          ...this.camera,
          position: { x: videoCoords.x, y: videoCoords.y },
          size: { width: videoCoords.width, height: videoCoords.height }
        })
        
        // 发送摄像头配置给后端

        
        showToast('摄像头已开启', 'success')
      } catch (error) {
        console.error('开启摄像头失败:', error)
        showToast('开启摄像头失败，请检查权限设置', 'error')
        this.camera.enabled = false
      }
    },
    
    stopCamera() {
      this.stopRealCamera()
      
      // 同时清除Dashboard的video元素的流
      if (this.$refs.localCameraVideo) {
        this.$refs.localCameraVideo.srcObject = null
      }
      if (this.$refs.cameraVideoElement) {
        this.$refs.cameraVideoElement.srcObject = null
      }
      

    },
    




    onStreamError() {
      console.error('直播流加载失败')
    },

    startPlaybackWatchdog() {
      const playbackWatchdog = this.playbackWatchdog;
      const isPlaying = this.isPlaying;
      const globalVideo = this.getGlobalVideo();
      const duration = this.duration;
      if (playbackWatchdog) clearInterval(playbackWatchdog)
      // 记录启动时间，给予 1 秒的宽限期，防止播放启动瞬间被误判为卡死
      const startTime = Date.now()
      this.playbackWatchdog = setInterval(() => {
        if (isPlaying && globalVideo && duration > 0) {
          // 如果还在宽限期内，跳过检查
          if (Date.now() - startTime < 1000) return
          const remaining = duration - globalVideo.currentTime
          // 如果视频非常接近末尾（小于 0.15s）或者已经停止但 isPlaying 仍为 true
          // 增加对 seeking 状态的检查，正在跳转时不触发
          if (remaining < 0.15 || (globalVideo.paused && !globalVideo.seeking)) {
            console.log(`[监控器] 检测到播放停滞 (剩余: ${remaining.toFixed(3)}s, 状态: ${globalVideo.paused ? '暂停' : '运行'}), 强制触发循环...`)
            this.onVideoEnded()
          }
        }
      }, 500) // 增加检查间隔，减少 CPU 开销
    },

    async togglePlay() {



      const globalVideo = this.getGlobalVideo()



      const isPlaying = this.isPlaying;
      const audioCtx = this.audioCtx;
      const overlayVideoPlayer = this.getOverlayVideo();

      // 先锁定当前播放时间，防止异步操作导致时间跳变
      const currentPos = globalVideo?.currentTime || 0;
      this.isPlaying = !isPlaying
      this.localIsPlaying = this.isPlaying // 🔧 同时更新本地播放状态



      if (globalVideo) {
        if (!isPlaying) {
          // 核心：播放前确保 AudioContext 已恢复
          if (audioCtx && audioCtx.state === 'suspended') {
            await audioCtx.resume()
          }

          // 开启监控
          this.startPlaybackWatchdog()

          // 点击播放按钮时，从当前位置继续播放，而不是从头开始
          const resumeTime = currentPos || 0;
          

          // 延迟启动音频，对齐后端渲染和传输延迟（0表示无延迟）
          const audioDelay = this.isVirtualCameraLive ? 0 : 0;
          setTimeout(() => {
            if (this.isPlaying && globalVideo && this.isPageActive) {
              this.setGlobalVideoMuted(false); // 确保播放时取消静音
              this.playGlobalVideo();
              // 开始渲染到画布
              this.startVideoRender();
            }
          }, audioDelay);

          this.playOverlayVideo();
          this.resetHideTimer();
        } else {
          this.stopPlaybackWatchdog()
          this.pauseGlobalVideo()
          this.pauseOverlayVideo()
          if (this.isVirtualCameraLive) {
            console.log('[同步] 暂停播放，指令下发中... 时间:', currentPos);

          }
        }
      }
    },
    stopPlaybackWatchdog() {
      if (this.playbackWatchdog) {
        clearInterval(this.playbackWatchdog)
        this.playbackWatchdog = null
      }
    },
    resetHideTimer() {
      if (this.hideTimer) clearTimeout(this.hideTimer)
      this.showControls = true
      if (this.isPlaying) {
        this.hideTimer = setTimeout(() => {
          this.showControls = false
        }, 3000)
      }
    },
    safePause(player) {
      if (!player || player.paused) return
      try {
        player.pause()
      } catch (e) {
        console.warn('Pause failed:', e)
      }
    },

    hiddenPlayerStyle() {
      return {
        position: 'absolute',
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        // 视频应该始终可见，只有推流时的流预览才在上面
        opacity: this.isVirtualCameraLive ? 0 : 1,
        pointerEvents: this.isVirtualCameraLive ? 'none' : 'auto'
      }
    },
    onVideoLoaded() {
      const globalVideo = this.getGlobalVideo()
      if (globalVideo) {
        this.duration = globalVideo.duration
        
        // 视频加载完成后，立即设置 canvas 为视频的原始分辨率，保持原画质
        if (globalVideo.videoWidth > 0 && globalVideo.videoHeight > 0 && this.videoCanvas && this.videoCtx) {
          this.videoCanvas.width = globalVideo.videoWidth
          this.videoCanvas.height = globalVideo.videoHeight
          
          // 设置高质量图像平滑模式
          this.videoCtx.imageSmoothingEnabled = true
          this.videoCtx.imageSmoothingQuality = 'high'
          
          console.log('[Canvas] 设置画布分辨率为视频原始尺寸:', 
            globalVideo.videoWidth, 'x', globalVideo.videoHeight)
        }
        
        // 设置音频输出设备
        if (this.audioSettings.driver) {
          this.changeAudioOutput(this.audioSettings.driver);
        }
        
        // 同步到 store
        if (this.$store.state.currentMedia) {
          this.$store.commit('UPDATE_MEDIA_STATE', {
            duration: this.duration
          })
        }
      }
    },
    onVideoEnded() {
      if (this.videoPlaylist.length > 1 && this.material.playMode === 'sequence') {
        this.playNextVideo()
      } else if (this.material.playMode === 'loop') {
        const globalVideo = this.getGlobalVideo()
        if (globalVideo) {
          this.setGlobalVideoCurrentTime(0)
          this.playGlobalVideo()
        }
      } else {
        this.isPlaying = false
        this.localIsPlaying = false
      }
    },


    updateProgress() {
      const globalVideo = this.getGlobalVideo()
      if (globalVideo) {
        this.currentTime = globalVideo.currentTime
        // 🔧 无论页面是否活跃，都要同步播放进度到 store
        // 页面活跃时每 2 秒同步一次，页面不活跃时每 5 秒同步一次，减少性能消耗
        const syncInterval = this.isPageActive ? 2 : 5
        if (Math.floor(this.currentTime) % syncInterval === 0) {
          this.syncVideoStateToStore()
        }
      }
    },

    onVideoPlay() {
      this.isPlaying = true
      this.localIsPlaying = true
      this.syncVideoStateToStore()
    },

    onVideoPause() {
      this.isPlaying = false
      this.localIsPlaying = false
      this.syncVideoStateToStore()
    },

    syncVideoStateToStore() {
      const globalVideo = this.getGlobalVideo()
      if (globalVideo && this.$store.state.currentMedia) {
        // 🔧 重要：即使页面不活跃，也要同步播放状态到 store，确保其他页面能获得最新状态
        this.$store.commit('UPDATE_MEDIA_STATE', {
          currentTime: this.currentTime,
          isPlaying: this.isPlaying,
          duration: this.duration
        })
      }
    },

    seekVideo(e) {
      const globalVideo = this.getGlobalVideo()
      if (!globalVideo || !globalVideo.duration) return
      
      const rect = e.currentTarget.getBoundingClientRect()
      const percent = (e.clientX - rect.left) / rect.width
      this.setGlobalVideoCurrentTime(percent * globalVideo.duration)
      

    },
    onVideoSeeked() {

    },
    async updateVideoVolume() {
      await delay(30);

      const globalVideo = this.getGlobalVideo()
      if (globalVideo) {
        globalVideo.volume = this.material.volume / 100
      }
    },
    updateOverlayVideoVolume() {
      const overlayVideoPlayer = this.$refs.overlayVideoPlayer

      if (overlayVideoPlayer) {
        overlayVideoPlayer.volume = this.overlay.volume / 100
        overlayVideoPlayer.muted = this.overlay.volume === 0
      }
    },


    // 实时变速
    startPlaybackSpeed() {
      this.schedulePlaybackSpeedChange()
    },
    stopPlaybackSpeed() {
      if (this.effectTimers.playbackSpeed) {
        clearTimeout(this.effectTimers.playbackSpeed)
        delete this.effectTimers.playbackSpeed
      }
      // 恢复正常播放速度
      const globalVideo = this.getGlobalVideo()
      if (globalVideo) globalVideo.playbackRate = 1
    },
    schedulePlaybackSpeedChange() {
      if (!this.playbackSpeed.enabled) return
      const interval = this.playbackSpeed.intervalStart + 
        Math.random() * (this.playbackSpeed.intervalEnd - this.playbackSpeed.intervalStart)
      this.effectTimers.playbackSpeed = setTimeout(() => {
        this.applyPlaybackSpeed()
        this.schedulePlaybackSpeedChange()
      }, interval * 1000)
    },
    applyPlaybackSpeed() {
      const globalVideo = this.getGlobalVideo()
      if (!globalVideo) return
      
      let speedMultiplier
      switch(this.playbackSpeed.mode) {
        case 'micro':
          speedMultiplier = 0.9 + Math.random() * 0.2 // 0.9 - 1.1
          break
        case 'medium':
          speedMultiplier = 0.7 + Math.random() * 0.6 // 0.7 - 1.3
          break
        case 'heavy':
          speedMultiplier = 0.5 + Math.random() * 1.0 // 0.5 - 1.5
          break
        default:
          speedMultiplier = 1
      }
      globalVideo.playbackRate = speedMultiplier
    },

    // 实时抽帧
    startFrameCapture() {
      this.scheduleFrameCapture()
    },
    stopFrameCapture() {
      if (this.effectTimers.frameCapture) {
        clearTimeout(this.effectTimers.frameCapture)
        delete this.effectTimers.frameCapture
      }
    },
    scheduleFrameCapture() {
      if (!this.frameCapture.enabled) return
      
      // 在设定的间隔范围内随机选择一个时间
      const interval = this.frameCapture.intervalMin + 
        Math.random() * (this.frameCapture.intervalMax - this.frameCapture.intervalMin)
      
      this.effectTimers.frameCapture = setTimeout(() => {
        this.captureFrames()
        this.scheduleFrameCapture()
      }, interval * 1000)
    },
    captureFrames() {
      const globalVideo = this.getGlobalVideo()
      if (!globalVideo) return
      
      const framesToSkip = this.frameCapture.frameCount || 1
      const skipTime = framesToSkip * 0.1 // 每帧约0.1秒，跳过指定帧数
      
      if (globalVideo.currentTime + skipTime < globalVideo.duration) {
        this.setGlobalVideoCurrentTime(globalVideo.currentTime + skipTime)
      } else if (this.material.playMode === 'loop') {
        this.setGlobalVideoCurrentTime(0)
      }
    },
    addFile(e) {
      if (e) e.stopPropagation()
      if (e) e.preventDefault()
      
      try {
        const fileInput = this.$refs.fileInput
        if (fileInput) {
          fileInput.value = ''
          fileInput.click()
        }
      } catch (err) {
        console.error('[选择文件] 触发文件选择器失败:', err)
      }
    },
    async addFolder() {
      const folderInput = this.$refs.folderInput
      if (folderInput) {
        folderInput.value = ''
        folderInput.click()
      }
    },
    async loadFolderVideos(folderPath, backendBase) {
      try {
        const response = await fetch(`${backendBase}/list_videos?path=${encodeURIComponent(folderPath)}`)
        if (!response.ok) {
          throw new Error('获取视频列表失败')
        }
        const data = await response.json()
        
        if (data.status === 'success' && data.videos && data.videos.length > 0) {
          this.videoPlaylist = data.videos.map(v => ({
            path: v.path,
            name: v.name
          }))
          this.currentPlaylistIndex = 0
          await this.playFromPlaylist(0)
        } else {
          console.warn('文件夹中没有找到视频文件')
        }
      } catch (error) {
        console.warn('加载文件夹视频失败:', error)
      }
    },
    async playFromPlaylist(index) {
      if (index < 0 || index >= this.videoPlaylist.length) return

      this.currentPlaylistIndex = index
      const video = this.videoPlaylist[index]
      
      const targetUrl = video.path

      this.material.path = video.path
      this.$store.commit('SET_CURRENT_MEDIA', {
        url: targetUrl,
        path: video.path,
        type: 'video'
      })
      

    },
    playNextVideo() {
      if (this.videoPlaylist.length === 0) return
      const nextIndex = (this.currentPlaylistIndex + 1) % this.videoPlaylist.length
      this.playFromPlaylist(nextIndex)
    },
    resetOverlay() {
      // 停止并清除遮罩视频元素
      const overlayVideo = this.getOverlayVideo()
      if (overlayVideo) {
        this.pauseOverlayVideo()
        this.setOverlayVideoSrc('1')
      }
      
      // 清除遮罩帧
      if (this.overlayFrameCanvas) {
        this.overlayFrameCanvas = null
        this.overlayFrameCtx = null
      }
      
      this.overlay.path = ''
      this.overlayInitialPath = '' // 重置初始路径变量
      this.overlayVideoUrl = ''
      this.overlayPlaylist = []
      showToast('遮罩已恢复默认', 'success')
    },
    async handleOverlayFileSelect(event) {
      const file = event.target.files[0]
      if (!file) return
      
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.avi', '.mov', '.mkv', '.flv', '.wmv', '.m4v', '.3gp', '.3g2']
      const ext = file.name.toLowerCase().substring(file.name.lastIndexOf('.'))
      if (!videoExtensions.includes(ext)) {
        showToast('请选择有效的视频文件', 'warning')
        event.target.value = ''
        return
      }
      
      const overlayVideo = this.getOverlayVideo()
      if (!overlayVideo) {
        showToast('无法获取遮罩视频元素', 'error')
        return
      }
      
      const blobUrl = this.createSafeBlobUrl(file)
      
      // 创建包含单个视频的播放列表
      this.overlayPlaylist = [{
        path: blobUrl,
        name: file.name
      }]
      this.overlayCurrentIndex = 0
      
      // 同步到 App.vue 的全局状态
      this.setOverlayPlaylist(this.overlayPlaylist)
      this.setOverlayPlayMode(this.overlay.playMode)
      
      // 设置视频属性
      overlayVideo.crossOrigin = 'anonymous'
      overlayVideo.loop = false  // 不循环播放，由 ended 事件控制
      // 根据设置的音量来决定是否静音
      overlayVideo.muted = this.overlay.volume === 0
      overlayVideo.volume = this.overlay.volume / 100
      
      // 设置音频输出设备
      if (this.audioSettings.driver) {
        this.updateAllVideosAudioSinkId(this.audioSettings.driver);
      }
      
      // 移除旧的监听器（如果有的话）
      if (this._overlayVideoLoadedHandler) {
        overlayVideo.removeEventListener('loadeddata', this._overlayVideoLoadedHandler)
      }
      if (this._overlayVideoErrorHandler) {
        overlayVideo.removeEventListener('error', this._overlayVideoErrorHandler)
      }
      
      // 定义事件处理函数
      this._overlayVideoLoadedHandler = () => {
        this.playOverlayVideo().catch(e => {
          console.warn('遮罩视频自动播放失败:', e)
        })
        // 同时也初始化遮罩 Canvas
        if (!this.overlayFrameCanvas) {
          this.overlayFrameCanvas = document.createElement('canvas')
          this.overlayFrameCtx = this.overlayFrameCanvas.getContext('2d')
        }
        
        this.overlayFrameCanvas.width = overlayVideo.videoWidth
        this.overlayFrameCanvas.height = overlayVideo.videoHeight
        
        // 保存文件信息
        this.overlay.path = file.name
        this.overlayInitialPath = file.name // 更新初始路径变量
        // 保留视频 URL 用于引用
        this.overlayVideoUrl = blobUrl
        
        showToast('遮罩视频已添加并自动播放！', 'success')
        
        // 移除事件监听器，防止重复触发
        overlayVideo.removeEventListener('loadeddata', this._overlayVideoLoadedHandler)
      }
      
      this._overlayVideoErrorHandler = (e) => {
        // 忽略正常的中止错误，只处理真实错误
        const video = e.target
        if (video.error) {
          const isAbort = video.error.code === 4 || video.error.message?.includes('ABORT')
          if (isAbort) {
            console.log('[遮罩播放器] 忽略中止错误:', video.error)
            return
          }
          // 解码错误等需要提示用户
          console.error('遮罩视频加载失败:', video.error)
          const errorMsg = video.error.code === 3 
            ? '遮罩视频解码失败，可能视频文件损坏或编码格式不支持'
            : '遮罩视频加载失败'
          showToast(errorMsg, 'error')
        }
      }
      
      // 添加新的监听器
      overlayVideo.addEventListener('loadeddata', this._overlayVideoLoadedHandler)
      overlayVideo.addEventListener('error', this._overlayVideoErrorHandler)
    },
    async handleOverlayFolderSelect(event) {
      const files = event.target.files
      if (!files || files.length === 0) return

      // 获取文件夹路径
      const firstFile = files[0]
      let folderPath = ''
      if (firstFile.webkitRelativePath) {
        const pathParts = firstFile.webkitRelativePath.split('/')
        folderPath = pathParts[0]
      }

      // 筛选视频文件
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.avi', '.mov', '.mkv', '.flv', '.wmv', '.m4v', '.3gp', '.3g2']
      const videoFiles = Array.from(files).filter(file => {
        const ext = file.name.toLowerCase().substring(file.name.lastIndexOf('.'))
        return videoExtensions.includes(ext)
      })

      if (videoFiles.length === 0) {
        console.warn('文件夹中没有找到视频文件')
        showToast('文件夹中没有找到视频文件', 'warning')
        // 清空 input 值，确保下次可以选择相同文件夹
        event.target.value = ''
        return
      }

      this.overlay.path = folderPath
      this.overlayInitialPath = folderPath // 更新初始路径变量

      // 创建临时播放列表
      this.overlayPlaylist = videoFiles.map((file, index) => ({
        path: URL.createObjectURL(file),
        name: file.name
      }))
      this.overlayCurrentIndex = 0

      // 同步到 App.vue 的全局状态
      this.setOverlayPlaylist(this.overlayPlaylist)
      this.setOverlayPlayMode(this.overlay.playMode)

      // 获取遮罩视频元素
      const overlayVideo = this.getOverlayVideo()
      if (!overlayVideo) {
        showToast('无法获取遮罩视频元素', 'error')
        // 清空 input 值，确保下次可以选择相同文件夹
        event.target.value = ''
        return
      }

      // 设置视频属性
      overlayVideo.crossOrigin = 'anonymous'
      overlayVideo.loop = false  // 不循环播放，由 ended 事件控制
      // 根据设置的音量来决定是否静音
      overlayVideo.muted = this.overlay.volume === 0
      overlayVideo.volume = this.overlay.volume / 100
      
      // 设置音频输出设备
      if (this.audioSettings.driver) {
        this.updateAllVideosAudioSinkId(this.audioSettings.driver);
      }

      // 移除旧的监听器（如果有的话）
      if (this._overlayVideoLoadedHandler) {
        overlayVideo.removeEventListener('loadeddata', this._overlayVideoLoadedHandler)
      }
      if (this._overlayVideoErrorHandler) {
        overlayVideo.removeEventListener('error', this._overlayVideoErrorHandler)
      }

      // 定义事件处理函数
      this._overlayVideoLoadedHandler = () => {
        this.playOverlayVideo().catch(e => {
          console.warn('遮罩视频自动播放失败:', e)
        })

        // 同时也初始化遮罩 Canvas
        if (!this.overlayFrameCanvas) {
          this.overlayFrameCanvas = document.createElement('canvas')
          this.overlayFrameCtx = this.overlayFrameCanvas.getContext('2d')
        }

        this.overlayFrameCanvas.width = overlayVideo.videoWidth
        this.overlayFrameCanvas.height = overlayVideo.videoHeight

        this.overlayVideoUrl = this.overlayPlaylist[0]?.path

        showToast(`已添加 ${this.overlayPlaylist.length} 个遮罩视频！`, 'success')

        // 移除事件监听器，防止重复触发
        overlayVideo.removeEventListener('loadeddata', this._overlayVideoLoadedHandler)
      }

      this._overlayVideoErrorHandler = (e) => {
        // 忽略正常的中止错误，只处理真实错误
        const video = e.target
        if (video.error) {
          const isAbort = video.error.code === 4 || video.error.message?.includes('ABORT')
          if (isAbort) {
            console.log('[遮罩播放器] 忽略中止错误:', video.error)
            return
          }
          // 解码错误等需要提示用户
          console.error('遮罩视频加载失败:', video.error)
          const errorMsg = video.error.code === 3 
            ? '遮罩视频解码失败，可能视频文件损坏或编码格式不支持'
            : '遮罩视频加载失败'
          showToast(errorMsg, 'error')
        }
      }

      // 添加新的监听器
      overlayVideo.addEventListener('loadeddata', this._overlayVideoLoadedHandler)
      overlayVideo.addEventListener('error', this._overlayVideoErrorHandler)

      // 清空 input 值，确保下次可以选择相同文件夹
      event.target.value = ''
    },
    async addOverlayFile(e) {
      if (e) e.stopPropagation()
      try {
        this.$refs.overlayFileInput.click()
      } catch (error) {
        console.error('触发文件选择失败:', error)
      }
    },
    async addOverlayFolder() {
      const folderInput = this.$refs.overlayFolderInput
      if (folderInput) {
        folderInput.value = ''
        folderInput.click()
      }
    },
    handleImageFolderSelect(event) {
      const files = event.target.files
      if (!files || files.length === 0) return

      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.tiff', '.svg']
      const imageFiles = Array.from(files).filter(file => {
        const ext = file.name.toLowerCase().substring(file.name.lastIndexOf('.'))
        return imageExtensions.includes(ext)
      })

      if (imageFiles.length === 0) {
        showToast('文件夹中没有找到图片文件', 'warning')
        event.target.value = ''
        return
      }

      // 获取文件夹路径
      const firstFile = files[0]
      let folderPath = ''
      if (firstFile.webkitRelativePath) {
        const pathParts = firstFile.webkitRelativePath.split('/')
        folderPath = pathParts[0]
      }
      this.imageOverlay.path = folderPath

      this.imageOverlay.images = imageFiles.map(file => ({
        url: this.createSafeBlobUrl(file),
        name: file.name
      }))
      
      if (this.imageOverlay.images.length > 0) {
        this.imageOverlay.currentIndex = 0
        this.imageOverlay.currentImage = this.imageOverlay.images[0].url
      }
      
      showToast(`已添加 ${imageFiles.length} 张图片！`, 'success')
      
      // 清空 input 值，确保下次可以选择相同文件夹
      event.target.value = ''
    },
    async addImageFolder() {
      const folderInput = this.$refs.imageOverlayFolderInput
      if (folderInput) {
        folderInput.value = ''
        folderInput.click()
      }
    },

    async handleFileSelect(event) {
      const file = event.target.files[0]
      if (!file) {
        return
      }
      
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.avi', '.mov', '.mkv', '.flv', '.wmv', '.m4v', '.3gp', '.3g2']
      const ext = file.name.toLowerCase().substring(file.name.lastIndexOf('.'))
      if (!videoExtensions.includes(ext)) {
        showToast('请选择有效的视频文件', 'warning')
        event.target.value = ''
        return
      }
      
      // 清空旧的播放列表
      this.videoPlaylist = []
      this.currentPlaylistIndex = 0
      
      // 设置 blob URL 用于本地预览
      const blobUrl = this.createSafeBlobUrl(file)
      
      // 创建包含单个视频的播放列表
      this.videoPlaylist = [{
        path: blobUrl,
        name: file.name
      }]
      this.currentPlaylistIndex = 0
      
      // 同步到 App.vue 的全局状态
      this.setPlaylist(this.videoPlaylist)
      this.setPlayMode(this.material.playMode)
      
      // 获取全局视频元素
      const globalVideo = this.getGlobalVideo()
      if (globalVideo) {
        // 设置视频属性，确保不循环播放，由 ended 事件控制
        globalVideo.loop = false
        // 根据设置的音量来决定是否静音
        globalVideo.muted = this.material.volume === 0
        globalVideo.volume = this.material.volume / 100





        // 设置音频输出设备
        if (this.audioSettings.driver) {
          this.updateAllVideosAudioSinkId(this.audioSettings.driver);
        }
        globalVideo.play().catch(e => {
          console.warn('自动播放失败:', e)
        })

        // 移除旧的监听器（如果有的话）
     /*   if (this._globalVideoLoadedHandler) {
          globalVideo.removeEventListener('loadeddata', this._globalVideoLoadedHandler)
        }
        if (this._globalVideoErrorHandler) {
          globalVideo.removeEventListener('error', this._globalVideoErrorHandler)
        }
        
        // 定义事件处理函数
        this._globalVideoLoadedHandler = () => {
          globalVideo.play().catch(e => {
            console.warn('自动播放失败:', e)
          })
          // 移除监听器，防止重复触发
          globalVideo.removeEventListener('loadeddata', this._globalVideoLoadedHandler)
        }
        
        this._globalVideoErrorHandler = (e) => {
          // 忽略正常的中止错误，只处理真实错误
          const video = e.target
          if (video.error) {
            const isAbort = video.error.code === 4 || video.error.message?.includes('ABORT')
            if (isAbort) {
              console.log('[播放器] 忽略中止错误:', video.error)
              return
            }
            // 解码错误等需要提示用户
            console.error('视频加载失败:', video.error)
            const errorMsg = video.error.code === 3 
              ? '视频解码失败，可能视频文件损坏或编码格式不支持'
              : '视频加载失败'
            showToast(errorMsg, 'error')
          }
        }
        
        // 添加新的监听器
        globalVideo.addEventListener('loadeddata', this._globalVideoLoadedHandler)
        globalVideo.addEventListener('error', this._globalVideoErrorHandler)*/
      }
      
      // 设置文件名就行，不需要上传
      this.material.path = file.name
      this.materialInitialPath = file.name // 更新初始路径变量
      
      // 更新 store
      this.$store.commit('SET_CURRENT_MEDIA', {
        url: blobUrl,
        path: file.name,
        type: 'video'
      })

      showToast('视频已选择，正在自动播放！', 'success')
    },
    async handleFolderSelect(event) {
      const files = event.target.files
      if (!files || files.length === 0) return

      // 获取文件夹路径
      const firstFile = files[0]
      let folderPath = ''
      if (firstFile.webkitRelativePath) {
        const pathParts = firstFile.webkitRelativePath.split('/')
        folderPath = pathParts[0]
      }

      // 筛选视频文件
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.avi', '.mov', '.mkv', '.flv', '.wmv', '.m4v', '.3gp', '.3g2']
      const videoFiles = Array.from(files).filter(file => {
        const ext = file.name.toLowerCase().substring(file.name.lastIndexOf('.'))
        return videoExtensions.includes(ext)
      })

      if (videoFiles.length === 0) {
        console.warn('文件夹中没有找到视频文件')
        showToast('文件夹中没有找到视频文件', 'warning')
        // 清空 input 值，确保下次可以选择相同文件夹
        event.target.value = ''
        return
      }

      this.material.path = folderPath
      this.materialInitialPath = folderPath // 更新初始路径变量

      // 创建临时播放列表
      this.videoPlaylist = videoFiles.map((file, index) => ({
        path: URL.createObjectURL(file),
        name: file.name
      }))
      this.currentPlaylistIndex = 0

      // 同步到 App.vue 的全局状态
      this.setPlaylist(this.videoPlaylist)
      this.setPlayMode(this.material.playMode)

      // 获取全局视频元素
      const globalVideo = this.getGlobalVideo()
      if (globalVideo) {
        // 设置视频属性，确保不循环播放，由 ended 事件控制
        globalVideo.loop = false
        // 根据设置的音量来决定是否静音
        globalVideo.muted = this.material.volume === 0
        globalVideo.volume = this.material.volume / 100
        
        // 设置音频输出设备
        if (this.audioSettings.driver) {
          this.updateAllVideosAudioSinkId(this.audioSettings.driver);
        }

        globalVideo.play().catch(e => {
          console.warn('自动播放失败:', e)
        })

        /*
        // 移除旧的监听器（如果有的话）
        if (this._globalVideoLoadedHandler) {
          globalVideo.removeEventListener('loadeddata', this._globalVideoLoadedHandler)
        }
        if (this._globalVideoErrorHandler) {
          globalVideo.removeEventListener('error', this._globalVideoErrorHandler)
        }

        // 定义事件处理函数
        this._globalVideoLoadedHandler = () => {
          globalVideo.play().catch(e => {
            console.warn('自动播放失败:', e)
          })
          // 移除监听器，防止重复触发
          globalVideo.removeEventListener('loadeddata', this._globalVideoLoadedHandler)
        }

        this._globalVideoErrorHandler = (e) => {
          // 忽略正常的中止错误，只处理真实错误
          const video = e.target
          if (video.error) {
            const isAbort = video.error.code === 4 || video.error.message?.includes('ABORT')
            if (isAbort) {
              console.log('[播放器] 忽略中止错误:', video.error)
              return
            }
          }
          console.error('视频加载失败:', e)
          showToast('视频加载失败', 'error')
        }

        // 添加新的监听器
        globalVideo.addEventListener('loadeddata', this._globalVideoLoadedHandler)
        globalVideo.addEventListener('error', this._globalVideoErrorHandler)*/
      }

      // 更新 store
      const firstVideo = this.videoPlaylist[0]
      this.$store.commit('SET_CURRENT_MEDIA', {
        url: firstVideo.path,
        path: firstVideo.path,
        type: 'video'
      })
      
      showToast(`已添加 ${this.videoPlaylist.length} 个视频！`, 'success')

      // 清空 input 值，确保下次可以选择相同文件夹
      event.target.value = ''
    },
    resetMaterial() {
      // 停止并清除主视频元素
      const globalVideo = this.getGlobalVideo()
      if (globalVideo) {
        this.$store.commit('SET_CURRENT_MEDIA', {
          url: "",
          path: "",
          type: 'video'
        })
        this.pauseGlobalVideo()
        this.setGlobalVideoSrc('1')

      }
      
      this.material.path = ''
      this.materialInitialPath = '' // 重置初始路径变量
      this.videoPlaylist = []
      this.currentPlaylistIndex = 0
      showToast('素材已恢复默认', 'success')
    },
    handlePathEnter() {
      if (!this.materialInitialPath) {
        showToast('请输入视频路径', 'warning')
        return
      }
      
      if (this.material.source === 'cloud') {
        this.playCloudVideo()
      } else {
        // 如果是本地模式，可以在这里添加本地文件处理逻辑
        showToast('请使用文件或文件夹按钮选择本地视频', 'info')
      }
    },
    playCloudVideo() {
      const url = this.materialInitialPath.trim()
      this.eSend("parse",{
        url,
        type:"play"
      })
      if (!url) {
       // showToast('请输入有效的云存储视频链接', 'warning')
        return
      }
      console.log('[云存储] 正在播放视频:', url)
      // 更新 store 中的当前媒体
      this.$store.commit('SET_CURRENT_MEDIA', {
        url: url,
        path: url,
        type: 'video'
      })
      
      // 设置全局视频源
      const globalVideo = this.getGlobalVideo()
      if (globalVideo) {
        this.setGlobalVideoSrc(url)
        this.updateVideoVolume()
        
        // 尝试自动播放
        this.$nextTick(() => {
          this.playGlobalVideo().catch(e => {
            console.warn('自动播放失败:', e)
            showToast('点击视频区域开始播放', 'info')
          })
        })
        showToast('正在加载云存储视频...', 'success')

      }
      
    },
    handleOverlayPathEnter() {
      if (!this.overlayInitialPath) {
        showToast('请输入遮罩视频路径', 'warning')
        return
      }
      
      if (this.overlay.source === 'cloud') {
        this.playOverlayCloudVideo()
      } else {
        // 如果是本地模式，可以在这里添加本地文件处理逻辑
        showToast('请使用文件或文件夹按钮选择本地遮罩视频', 'info')
      }
    },
    playOverlayCloudVideo() {
      const url = this.overlayInitialPath.trim()
      this.eSend("parse", {
        url:url,
        type:"overlay"
      })
      if (!url) {
        showToast('请输入有效的云存储遮罩视频链接', 'warning')
        return
      }
      
      console.log('[云存储] 正在播放遮罩视频:', url)
      
      // 设置遮罩视频源
      this.setOverlayVideoSrc(url)
      
      const overlayVideo = this.getOverlayVideo()
      if (overlayVideo) {
        // 设置音量
        overlayVideo.muted = this.overlay.volume === 0
        overlayVideo.volume = this.overlay.volume / 100
        
        // 设置音频输出设备
        if (this.audioSettings.driver) {
          this.updateAllVideosAudioSinkId(this.audioSettings.driver)
        }
        
        // 尝试自动播放
        this.$nextTick(() => {
          this.playOverlayVideo().catch(e => {
            console.warn('遮罩视频自动播放失败:', e)
          })
        })
      }
      
      showToast('正在加载云存储遮罩视频...', 'success')
    },
    initEffectsCanvas() {
      if (!this.$refs.effectsCanvas) return
      this.effectsCanvas = this.$refs.effectsCanvas
      this.effectsCtx = this.effectsCanvas.getContext('2d')
      // 确保在下一个 tick 中获取正确的容器尺寸
      this.$nextTick(() => {
        if (!this.effectsCanvas) return
        const container = this.effectsCanvas.parentElement
        if (container) {
          this.effectsCanvas.width = container.offsetWidth || 540
          this.effectsCanvas.height = container.offsetHeight || 960
        }
      })
    },
    startEffectsAnimation() {
      if (this.effectsAnimationId) return
      const animate = () => {
        this.drawEffects()
        this.effectsAnimationId = requestAnimationFrame(animate)
      }
      animate()
    },
    stopEffectsAnimation() {
      if (this.effectsAnimationId) {
        cancelAnimationFrame(this.effectsAnimationId)
        this.effectsAnimationId = null
      }
      if (this.effectsCtx) {
        this.effectsCtx.clearRect(0, 0, this.effectsCanvas?.width || 0, this.effectsCanvas?.height || 0)
      }
    },
    startEffectsSwitch() {
      this.stopEffectsSwitch()
      this.scheduleEffectSwitch()
    },
    scheduleEffectSwitch() {
      if (!this.effects.enabled) return
      // 随机 10-30 秒后切换
      const interval = 10000 + Math.random() * 20000
      this.effectsSwitchTimer = setTimeout(() => {
        this.switchEffect()
        this.scheduleEffectSwitch()
      }, interval)
    },
    stopEffectsSwitch() {
      if (this.effectsSwitchTimer) {
        clearTimeout(this.effectsSwitchTimer)
        this.effectsSwitchTimer = null
      }
    },
    switchEffect() {
      if (this.effects.playMode === 'fixed') {
        // 固定播放模式：不切换特效，保持当前选择的特效
        return
      } else if (this.effects.playMode === 'sequence') {
        this.currentEffectIndex = (this.currentEffectIndex + 1) % this.effectsList.length
        this.effects.type = this.effectsList[this.currentEffectIndex]
      } else {
        let newIndex
        do {
          newIndex = Math.floor(Math.random() * this.effectsList.length)
        } while (newIndex === this.currentEffectIndex && this.effectsList.length > 1)
        this.currentEffectIndex = newIndex
        this.effects.type = this.effectsList[this.currentEffectIndex]
      }
    },
    drawEffects() {
      if (!this.effectsCanvas || !this.effectsCtx || !this.effects.enabled) return
      
      const ctx = this.effectsCtx
      const w = this.effectsCanvas.width
      const h = this.effectsCanvas.height
      
      ctx.clearRect(0, 0, w, h)
      this.effectsTime++
      
      switch(this.effects.type) {
        case '字幕雨':
          this.drawTextRain(ctx, w, h)
          break
        case '雪花':
          this.drawSnow(ctx, w, h)
          break
        case '星空':
          this.drawStarfield(ctx, w, h)
          break
        case '动态杂点':
          this.drawNoise(ctx, w, h)
          break
        case '粒子线条':
          this.drawParticleLines(ctx, w, h)
          break
        case '彩色光斑':
          this.drawColorBokeh(ctx, w, h)
          break
        case '动态扫描线':
          this.drawScanlines(ctx, w, h)
          break
        case '混沌透视重塑':
          this.drawChaos(ctx, w, h)
          break

        case '色彩偏移':
          this.drawColorShift(ctx, w, h)
          break
        case '边缘流光':
          this.drawEdgeGlow(ctx, w, h)
          break
        case 'AI像素重组':
          this.drawPixelRecombine(ctx, w, h)
          break
      }
    },
    drawTextRain(ctx, w, h) {
      const chars = '01アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン'
      if (this.effectsParticles.length === 0) {
        for (let i = 0; i < 30; i++) {
          this.effectsParticles.push({
            x: Math.random() * w,
            y: Math.random() * -h,
            speed: 2 + Math.random() * 4,
            char: chars[Math.floor(Math.random() * chars.length)],
            size: 32 + Math.random() * 32 // 文字大小增大了
          })
        }
      }
      ctx.fillStyle = '#00d4ff'
      this.effectsParticles.forEach(p => {
        ctx.font = `${p.size}px monospace` // 使用每个粒子的动态大小
        ctx.fillText(p.char, p.x, p.y)
        p.y += p.speed
        if (p.y > h) {
          p.y = -20
          p.x = Math.random() * w
          p.char = chars[Math.floor(Math.random() * chars.length)]
        }
      })
    },
    drawSnow(ctx, w, h) {
      if (this.effectsParticles.length === 0) {
        for (let i = 0; i < 80; i++) {
          this.effectsParticles.push({
            x: Math.random() * w,
            y: Math.random() * h,
            r: 1 + Math.random() * 3,
            speed: 0.5 + Math.random() * 1.5,
            drift: -0.5 + Math.random()
          })
        }
      }
      ctx.fillStyle = 'rgba(255,255,255,0.8)'
      this.effectsParticles.forEach(p => {
        ctx.beginPath()
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2)
        ctx.fill()
        p.y += p.speed
        p.x += Math.sin(this.effectsTime * 0.02 + p.y * 0.1) * 0.5
        if (p.y > h) {
          p.y = -10
          p.x = Math.random() * w
        }
      })
    },
    drawStarfield(ctx, w, h) {
      if (this.effectsParticles.length === 0) {
        for (let i = 0; i < 100; i++) {
          this.effectsParticles.push({
            x: Math.random() * w,
            y: Math.random() * h,
            r: 0.5 + Math.random() * 1.5,
            twinkle: Math.random() * Math.PI * 2
          })
        }
      }
      this.effectsParticles.forEach(p => {
        const alpha = 0.5 + Math.sin(this.effectsTime * 0.05 + p.twinkle) * 0.5
        ctx.fillStyle = `rgba(255,255,255,${alpha})`
        ctx.beginPath()
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2)
        ctx.fill()
      })
    },
    drawNoise(ctx, w, h) {
      // 创建临时画布来生成杂点
      if (!this.noiseCanvas) {
        this.noiseCanvas = document.createElement('canvas')
        this.noiseCtx = this.noiseCanvas.getContext('2d')
      }
      
      this.noiseCanvas.width = w
      this.noiseCanvas.height = h
      
      const imageData = this.noiseCtx.createImageData(w, h)
      const data = imageData.data
      
      // 加重杂点效果
      for (let i = 0; i < data.length; i += 4) {
        const v = Math.random() * 200 // 增加灰度范围
        const alpha = 50 + Math.random() * 100 // 加重透明度
        data[i] = v
        data[i + 1] = v
        data[i + 2] = v
        data[i + 3] = alpha
      }
      
      this.noiseCtx.putImageData(imageData, 0, 0)
      
      // 使用 drawImage 而不是 putImageData，这样不会覆盖视频
      ctx.drawImage(this.noiseCanvas, 0, 0)
      
      // 添加第二层杂点，加重效果
      if (Math.random() > 0.3) {
        for (let i = 0; i < 50; i++) {
          const x = Math.random() * w
          const y = Math.random() * h
          const size = 2 + Math.random() * 4
          ctx.fillStyle = `rgba(255, 255, 255, ${Math.random() * 0.8})`
          ctx.fillRect(x, y, size, size)
        }
      }
    },
    drawParticleLines(ctx, w, h) {
      if (this.effectsParticles.length === 0) {
        // 增加粒子数量
        for (let i = 0; i < 60; i++) {
          this.effectsParticles.push({
            x: Math.random() * w,
            y: Math.random() * h,
            vx: (Math.random() - 0.5) * 3,
            vy: (Math.random() - 0.5) * 3
          })
        }
      }
      // 增强线条效果
      ctx.strokeStyle = 'rgba(0, 212, 255, 0.5)'
      ctx.lineWidth = 2
      for (let i = 0; i < this.effectsParticles.length; i++) {
        for (let j = i + 1; j < this.effectsParticles.length; j++) {
          const p1 = this.effectsParticles[i]
          const p2 = this.effectsParticles[j]
          const dist = Math.hypot(p1.x - p2.x, p1.y - p2.y)
          // 增加连接距离
          if (dist < 150) {
            ctx.beginPath()
            ctx.moveTo(p1.x, p1.y)
            ctx.lineTo(p2.x, p2.y)
            ctx.stroke()
          }
        }
      }
      // 增大粒子点
      this.effectsParticles.forEach(p => {
        ctx.fillStyle = '#00d4ff'
        ctx.beginPath()
        ctx.arc(p.x, p.y, 3, 0, Math.PI * 2)
        ctx.fill()
        p.x += p.vx
        p.y += p.vy
        if (p.x < 0 || p.x > w) p.vx *= -1
        if (p.y < 0 || p.y > h) p.vy *= -1
      })
    },
    drawColorBokeh(ctx, w, h) {
      const colors = ['#ff6b6b', '#4ecdc4', '#ffe66d', '#a29bfe', '#00d4ff']
      if (this.effectsParticles.length === 0) {
        for (let i = 0; i < 15; i++) {
          this.effectsParticles.push({
            x: Math.random() * w,
            y: Math.random() * h,
            r: 20 + Math.random() * 60,
            color: colors[Math.floor(Math.random() * colors.length)],
            speed: 0.2 + Math.random() * 0.5
          })
        }
      }
      this.effectsParticles.forEach(p => {
        const grad = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r)
        grad.addColorStop(0, p.color + '80')
        grad.addColorStop(1, p.color + '00')
        ctx.fillStyle = grad
        ctx.beginPath()
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2)
        ctx.fill()
        p.y -= p.speed
        if (p.y < -p.r) p.y = h + p.r
      })
    },
    drawScanlines(ctx, w, h) {
      ctx.fillStyle = 'rgba(0, 212, 255, 0.1)'
      for (let y = 0; y < h; y += 4) {
        if ((y + Math.floor(this.effectsTime * 0.5)) % 8 < 4) {
          ctx.fillRect(0, y, w, 2)
        }
      }
    },
    drawChaos(ctx, w, h) {
      ctx.save()
      ctx.translate(w / 2, h / 2)
      const t = this.effectsTime * 0.01
      for (let i = 0; i < 5; i++) {
        ctx.rotate(t * (i + 1) * 0.1)
        ctx.strokeStyle = `hsla(${(this.effectsTime + i * 50) % 360}, 70%, 60%, 0.3)`
        ctx.lineWidth = 2
        ctx.strokeRect(-w / 4 + i * 20, -h / 4 + i * 20, w / 2 - i * 40, h / 2 - i * 40)
      }
      ctx.restore()
    },
    /*drawMoire(ctx, w, h) {
      // 新效果：动态扫描线和条纹
      const t = this.effectsTime * 0.05
      
      // 绘制横向扫描线
      ctx.strokeStyle = 'rgba(0, 212, 255, 0.3)'
      ctx.lineWidth = 3
      for (let i = 0; i < h; i += 15) {
        const offset = Math.sin(t + i * 0.02) * 20
        ctx.beginPath()
        ctx.moveTo(0 + offset, i)
        ctx.lineTo(w - offset, i)
        ctx.stroke()
      }
      
      // 绘制纵向扫描线
      ctx.strokeStyle = 'rgba(255, 107, 107, 0.2)'
      ctx.lineWidth = 2
      for (let i = 0; i < w; i += 20) {
        const offset = Math.cos(t + i * 0.015) * 15
        ctx.beginPath()
        ctx.moveTo(i, 0 + offset)
        ctx.lineTo(i, h - offset)
        ctx.stroke()
      }
      
      // 添加一些闪动的小方块
      for (let i = 0; i < 20; i++) {
        const x = Math.random() * w
        const y = Math.random() * h
        const size = 5 + Math.random() * 15
        const alpha = Math.abs(Math.sin(t + i)) * 0.5
        ctx.fillStyle = `rgba(78, 205, 196, ${alpha})`
        ctx.fillRect(x, y, size, size)
      }
    },*/
    drawColorShift(ctx, w, h) {
      const t = this.effectsTime * 0.05
      ctx.fillStyle = 'rgba(255, 0, 0, 0.1)'
      ctx.fillRect(Math.sin(t) * 5, 0, w, h)
      ctx.fillStyle = 'rgba(0, 255, 0, 0.1)'
      ctx.fillRect(-Math.sin(t) * 5, Math.cos(t) * 3, w, h)
      ctx.fillStyle = 'rgba(0, 0, 255, 0.1)'
      ctx.fillRect(0, -Math.cos(t) * 3, w, h)
    },
    drawEdgeGlow(ctx, w, h) {
      if (!w || !h) return
      
      const canvas = this.videoCanvas || this.effectsCanvas
      const time = Date.now() / 1000
      
      // 1. 核心：高随机性参数，确保每一秒的像素特征都不重复 (去重核心)
      // 使用 sine 波嵌套产生非线性速度
      const speedBase = time * 0.8
      const drift = Math.sin(time * 0.5) * 2.0
      const pos = (speedBase + drift) % 1.0

      const perimeter = 2 * (w + h)
      const currentDist = pos * perimeter

      // 2. 随机长度和粗细
      const lightLen = perimeter * (0.15 + Math.abs(Math.sin(time)) * 0.2)
      // 核心修复：前端 Canvas 的 lineWidth 是基于物理像素的
      // 为了与后端 1080p 效果一致，这里需要根据当前 canvas 高度进行缩放
      const lineWidth = (4 + Math.abs(Math.cos(time * 0.7)) * 8) * (h / 720)

      ctx.lineCap = 'round'

      const getPoint = (dist) => {
        dist = (dist + perimeter) % perimeter
        if (dist < w) return { x: dist, y: 0 }
        if (dist < w + h) return { x: w, y: dist - w }
        if (dist < 2 * w + h) return { x: w - (dist - (w + h)), y: h }
        return { x: 0, y: h - (dist - (2 * w + h)) }
      }

      // 3. 多重重叠流光，增加画面复杂度，干扰平台 MD5 和像素对比
      const layers = [
        { offset: 0, color: '0, 212, 255', opMult: 1.0 },
        { offset: perimeter * 0.5, color: '255, 107, 107', opMult: 0.6 }, // 对向流光
      ]

      layers.forEach(layer => {
        const startDist = (currentDist + layer.offset) % perimeter
        const segments = 15
        for (let i = 0; i < segments; i++) {
          const p1Dist = startDist + (i / segments) * lightLen
          const p2Dist = startDist + ((i + 1) / segments) * lightLen
          const p1 = getPoint(p1Dist)
          const p2 = getPoint(p2Dist)

          // 随机透明度抖动
          const flicker = 0.8 + Math.random() * 0.2
          const alpha = (i / segments) * 0.8 * layer.opMult * flicker

          ctx.strokeStyle = `rgba(${layer.color}, ${alpha})`
          ctx.lineWidth = lineWidth * (i / segments) // 头部粗尾部细
          ctx.beginPath()
          ctx.moveTo(p1.x, p1.y)
          ctx.lineTo(p2.x, p2.y)
          ctx.stroke()
        }
      })
    },
    drawPixelRecombine(ctx, w, h) {
      const blockSize = 20
      const t = this.effectsTime * 0.02
      for (let y = 0; y < h; y += blockSize) {
        for (let x = 0; x < w; x += blockSize) {
          const offsetX = Math.sin(t + x * 0.01 + y * 0.02) * 5
          const offsetY = Math.cos(t + x * 0.02 + y * 0.01) * 5
          ctx.fillStyle = `hsla(${((x + y) * 2 + this.effectsTime) % 360}, 70%, 50%, 0.15)`
          ctx.fillRect(x + offsetX, y + offsetY, blockSize - 2, blockSize - 2)
        }
      }
    },

    async handleEnabledChange() {
      let devices = await navigator.mediaDevices.enumerateDevices()
      let audioInputs = devices.filter(device => device.kind === 'audioinput')
      //匹配设备

      function getMatch(outputDevice) {

        if (!outputDevice?.label) return undefined;
        // 将 Output 替换为 Input，得到采集设备名称


        const targetCaptureName = outputDevice.label.replace("Input", "Output");

        // 在所有输入里精确匹配label
        return audioInputs.find(input => input.label === targetCaptureName);
      }
      // 当启用转播时，自动填充服务器地址
      if (this.localConfig.enabled) {
        const audioOut=this.audioDevices.find(d=>d.deviceId==this.audioSettings.driver);
        const dev=getMatch(audioOut);

        if(dev){
          this.localConfig.device_audio=dev.label;
          this.localConfig.device_video=this.cameraSettings.name
          this.eSend("start_rtmp",this.localConfig);
          showToast('手机转播已启用', 'success');
          console.log(this.localConfig)
        }else{
          showToast('音频输出驱动请选择其他设备', 'error');

          this.localConfig.enabled=false;


        }


      } else {
        this.eSend("stop_rtmp",{
          port:this.localConfig.port,
        })
        showToast('手机转播已关闭', 'info');
      }
    },
  }

}

</script>

<style scoped lang="scss">
.live-console {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #000;
}

.main-content {
  flex: 1;

  display: grid;
  grid-template-columns: minmax(0, 380px) minmax(0, 1fr) minmax(0, 380px);
  gap: 8px;
  padding: 0 0px 4px 20px;

  overflow: hidden;
  min-height: 0;
  min-width: 0;
  max-width: 1600px;
  width: 100%;

  position: relative;
  left: -10px;
  /* 极微调：向左移动一丢丢，解决视觉居中偏差 */
}

/* 统一居中包装 */
:deep(.dashboard-root), .feature-page, .hot-sale-page {

  display: flex;

  justify-content: center;
  width: 100%;

}

.side-panel {

  display: flex;

  flex-direction: column;
  gap: 8px;

  overflow-y: auto;
  padding-right: 4px;
  min-width: 0;

}

.side-panel.right{

  gap: 12px;


}

.side-panel::-webkit-scrollbar {
  width: 6px;

}

.side-panel::-webkit-scrollbar-track {
  background: #0a0a0a;

}

.side-panel::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 3px;

}

.side-panel::-webkit-scrollbar-thumb:hover {
  background: #444;

}

/* 指定面板特定压缩样式 */
.side-panel.left .panel-card {
  margin-bottom: 4px;
  /* 减小卡片间距 */
}

.side-panel.left .card-header {
  padding: 8px 14px;

}

.side-panel.left .card-body {
  padding: 6px 14px 8px 14px;

}

.side-panel.left .material-section {
  gap: 6px;

}

.side-panel.left .path-input-wrapper {
  margin-top: 6px;

}

.side-panel.left .tech-controls-inline {
  margin-top: 6px;

}

.side-panel.left .effects-row-main {
  margin-bottom: 10px;

}

.side-panel.left .effects-slider-group {
  margin-top: 6px;

}

.clock-card {

  display: none;

}

.panel-card {
  background: linear-gradient(180deg, #1a1a1a 0%, #151515 100%);
  border: 1px solid #2a2a2a;
  border-radius: 14px;

  overflow: hidden;

  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4),
  inset 0 1px 0 rgba(255, 255, 255, 0.05);

  transition: all 0.3s ease;
  min-width: 0;

}

.panel-card:hover {
  border-color: #3a3a3a;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.5),
  0 0 20px rgba(0, 212, 255, 0.08),
  inset 0 1px 0 rgba(255, 255, 255, 0.08);

}

.tech-card {

  position: relative;

}

.tech-card::before {
  content: '';

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.4), transparent);

}

.card-header {

  display: flex;

  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%);
  border-bottom: 1px solid #2a2a2a;
  color: #b0b0b0;
  font-size: 12px;
  font-weight: 600;

}

.reset-link-btn {

  margin-left: auto;
  background: #333333;
  border: 1px solid #444444;
  color: #888888;
  font-size: 11px;

  cursor: pointer;
  padding: 6px 12px;
  border-radius: 4px;

  transition: all 0.2s ease;
  font-weight: 600;
  height: 28px;

  display: flex;

  align-items: center;

  justify-content: center;

}

.reset-link-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
  color: #ffffff;

}

.icon-wrapper {
  width: 24px;
  height: 24px;

  display: flex;

  align-items: center;

  justify-content: center;
  background: rgba(0, 212, 255, 0.12);
  border-radius: 8px;
  color: #00d4ff;

}

.card-header svg {
  filter: drop-shadow(0 0 4px rgba(0, 212, 255, 0.4));

}

.header-toggle {

  margin-left: auto;

  display: flex;

  align-items: center;

  cursor: pointer;

  position: relative;

}

.header-toggle input {

  position: absolute;
  inset: 0;
  opacity: 0;

  cursor: pointer;

}

.card-body {
  padding: 10px 14px 12px 14px;

}

.material-top-row {

  display: flex;

  align-items: center;
  gap: 12px;
  margin-bottom: 0px;

  flex-wrap: wrap;
  min-width: 0;

}

.toggle {

  display: flex;

  align-items: center;
  gap: 8px;

  cursor: pointer;

  position: relative;

}

.toggle-label {
  font-size: 11px;
  color: #888;

}

.toggle input {

  position: absolute;
  inset: 0;
  opacity: 0;

  cursor: pointer;

}

.toggle-track {
  width: 44px;
  height: 22px;
  background: #2a2a2a;
  border-radius: 11px;

  position: relative;

  transition: all 0.2s ease;
  border: 1px solid #3a3a3a;

}

.toggle-track::after {
  content: '';

  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background: #666;
  border-radius: 50%;

  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);

}

.header-toggle input:checked + .toggle-track,
.toggle input:checked + .toggle-track {
  background: #00d4ff;
  border-color: #00d4ff;

}

.header-toggle input:checked + .toggle-track::after,
.toggle input:checked + .toggle-track::after {
  left: 26px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);

}

.select {
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%);
  border: 1px solid #2a2a2a;
  color: #ffffff;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;

  cursor: pointer;
  min-width: 90px;
  max-width: 100%;

  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);

  transition: all 0.2s ease;

}

.select:hover {
  border-color: #00d4ff;
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.25), inset 0 1px 2px rgba(0, 0, 0, 0.3);

}

.select:focus {

  outline: none;
  border-color: #00d4ff;
  box-shadow: 0 0 12px rgba(0, 212, 255, 0.35), inset 0 1px 2px rgba(0, 0, 0, 0.3);

}

.select option {
  background-color: #1a1a1a;
  color: #ffffff;
  padding: 8px 12px;

}

.btn-reset {
  background: linear-gradient(180deg, #202020 0%, #1a1a1a 100%);
  border: 1px solid #2a2a2a;
  color: #a0a0a0;
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 11px;

  cursor: pointer;

  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2),
  inset 0 1px 0 rgba(255, 255, 255, 0.05);

}

.btn-reset-small {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #a0a0a0;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;

  cursor: pointer;

  white-space: nowrap;

}

.btn-reset-small:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;

}

.btn-reset:hover {
  border-color: #00d4ff;
  color: #00d4ff;

}

.material-section {

  display: flex;

  flex-direction: column;
  gap: 8px;
  margin-bottom: 2px;

}

.material-section:last-child {
  margin-bottom: 0;

}

.material-top-row {

  display: flex;

  align-items: center;
  gap: 10px;

}

.tech-controls-inline {

  display: flex;
  gap: 12px;
  margin-top: 8px;

  flex-wrap: wrap;

}

.tech-control-item {
  flex: 1;

  display: flex;

  align-items: center;
  gap: 8px;
  min-width: 100px;

}

.tech-control-row {

  display: flex;

  align-items: center;
  gap: 12px;
  margin-top: 8px;

}

.slider-wrapper {
  flex: 1;

  display: flex;

  align-items: center;
  gap: 0px;

}

.tech-slider {
  flex: 1;
  max-width: 50px;

  -webkit-appearance: none;
  height: 4px;
  background: #2a2a2a;
  border-radius: 2px;

  outline: none;

}

.tech-slider::-webkit-slider-thumb {

  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  background: #00d4ff;
  border-radius: 50%;

  cursor: pointer;
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.5);

  transition: all 0.2s ease;

}

.tech-slider::-webkit-slider-thumb:hover {
  transform: scale(1.2);
  box-shadow: 0 0 15px rgba(0, 212, 255, 0.8);

}

.tech-value {
  font-size: 11px;
  color: #00d4ff;
  font-family: 'SF Mono', monospace;
  min-width: 28px;

  text-align: right;

}

/* 遮罩特效样式 */
.effects-section {
  margin-top: 0;
  padding: 0;

}

.effects-header {

  display: none;
  /* 已有卡片标题，隐藏这个 */
}

.effects-row-main {

  display: flex;

  align-items: center;
  gap: 12px;
  margin-bottom: 20px;

}

.tech-toggle {

  display: flex;

  align-items: center;
  gap: 8px;

  cursor: pointer;

  position: relative;

}

.tech-toggle input {

  position: absolute;
  inset: 0;
  opacity: 0;

  cursor: pointer;

}

.tech-toggle-track {
  width: 44px;
  height: 22px;
  background: #2a2a2a;
  border-radius: 11px;

  position: relative;

  transition: all 0.2s ease;
  border: 1px solid #3a3a3a;

}

.tech-toggle-track::after {
  content: '';

  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background: #666;
  border-radius: 50%;

  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);

}

.tech-toggle input:checked + .tech-toggle-track {
  background: #00d4ff;
  border-color: #00d4ff;

}

.tech-toggle input:checked + .tech-toggle-track::after {
  left: 26px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);

}

.toggle-label {
  font-size: 12px;
  color: #a0a0a0;
  min-width: 30px;

}

.effects-select {
  flex: 1;
  background: #111111;
  border: 2px solid #f39c12;
  color: #ffffff;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;

  cursor: pointer;

  outline: none;

  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'%3E%3C/path%3E%3C/svg%3E");

  background-repeat: no-repeat;

  background-position: right 10px center;
  padding-right: 30px;

  transition: all 0.2s ease;
  box-shadow: 0 0 5px rgba(243, 156, 18, 0.1);

}

.effects-select:hover {
  border-color: #ff9f43;
  box-shadow: 0 0 10px rgba(243, 156, 18, 0.2);

}

.effects-slider-group {
  margin-top: 14px;

  display: flex;

  align-items: center;
  gap: 12px;

}

.slider-label {
  font-size: 12px;
  color: #888;

  white-space: nowrap;
  min-width: 40px;

}

.effects-slider-wrapper {
  flex: 1;

  display: flex;

  align-items: center;
  gap: 10px;

}

.effects-slider {
  width: 100%;

  -webkit-appearance: none;
  height: 4px;
  background: #2a2a2a;
  border-radius: 2px;

  outline: none;

}

.effects-slider::-webkit-slider-thumb {

  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  background: #00d4ff;
  border-radius: 50%;

  cursor: pointer;
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.5);

  transition: all 0.2s ease;

}

.effects-slider::-webkit-slider-thumb:hover {
  transform: scale(1.2);
  box-shadow: 0 0 15px rgba(0, 212, 255, 0.8);

}

.effects-checkbox-row {
  margin-bottom: 16px;

}

.effects-checkbox {

  display: flex;

  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #888;

  cursor: pointer;

}

.effects-checkbox input {

  display: none;

}

.checkbox-box {
  width: 16px;
  height: 16px;
  border: 1px solid #444;
  border-radius: 4px;

  position: relative;

}

.effects-checkbox input:checked + .checkbox-box {
  background: #ff4757;
  border-color: #ff4757;

}

.effects-checkbox input:checked + .checkbox-box::after {
  content: '✓';

  position: absolute;

  color: white;
  font-size: 12px;
  left: 2px;
  top: -1px;

}

.effects-range-wrapper {
  padding: 10px 0;

}

.effects-range-track {
  height: 4px;
  background: #333;
  border-radius: 2px;

  position: relative;

}

.effects-range-fill {

  position: absolute;
  height: 100%;
  background: #ff4757;

}

.effects-range-handle {

  position: absolute;
  top: 50%;
  width: 12px;
  height: 12px;
  background: #ff4757;
  border-radius: 50%;
  transform: translate(-50%, -50%);

  cursor: pointer;
  box-shadow: 0 0 10px rgba(255, 71, 87, 0.5);

}

.material-label {
  color: #b0b0b0;
  font-size: 13px;

  white-space: nowrap;

}

.material-actions {

  display: flex;
  gap: 6px;

}

.action-btn {
  width: 32px;
  height: 32px;
  background: linear-gradient(180deg, #202020 0%, #1a1a1a 100%);
  border: 1px solid #2a2a2a;
  color: #a0a0a0;
  border-radius: 8px;

  cursor: pointer;

  display: flex;

  align-items: center;

  justify-content: center;

  transition: all 0.2s ease;

}

.action-btn:hover {
  border-color: #00d4ff;
  color: #00d4ff;
  box-shadow: 0 0 12px rgba(0, 212, 255, 0.25);

}

.action-btn.browse:hover {
  background: linear-gradient(180deg, rgba(0, 212, 255, 0.15) 0%, rgba(0, 212, 255, 0.08) 100%);

}

.action-btn.delete:hover {
  border-color: #ff4757;
  color: #ff4757;
  background: linear-gradient(180deg, rgba(255, 71, 87, 0.12) 0%, rgba(255, 71, 87, 0.06) 100%);
  box-shadow: 0 0 12px rgba(255, 71, 87, 0.25);

}

.path-input-wrapper {

  display: flex;

  align-items: center;
  gap: 8px;
  margin-top: 10px;

}

.path-input {
  flex: 1;
  min-width: 0;
  background: linear-gradient(180deg, #1a1a1a 0%, #121212 100%);
  border: 1px solid #2a2a2a;
  color: #c0c0c0;
  padding: 9px 14px;
  border-radius: 10px;
  font-size: 12px;
  font-family: 'SF Mono', monospace;

  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);

  transition: all 0.2s ease;

}

.path-input:hover {
  border-color: #00d4ff;
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.25), inset 0 1px 2px rgba(0, 0, 0, 0.3);

}

.path-input:focus {

  outline: none;
  border-color: #00d4ff;
  box-shadow: 0 0 12px rgba(0, 212, 255, 0.35), inset 0 1px 2px rgba(0, 0, 0, 0.3);

}

.path-input-actions {

  display: flex;
  gap: 4px;
  flex-shrink: 0;
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%);
  padding: 3px;
  border-radius: 8px;
  border: 1px solid #2a2a2a;

}

.path-btn {
  background: linear-gradient(180deg, #202020 0%, #1a1a1a 100%);
  border: 1px solid #2a2a2a;
  color: #a0a0a0;
  width: 32px;
  height: 32px;
  border-radius: 8px;

  cursor: pointer;

  transition: all 0.2s ease;

  display: flex;

  align-items: center;

  justify-content: center;

}

.path-btn:hover {
  border-color: #00d4ff;
  color: #00d4ff;
  background: linear-gradient(180deg, rgba(0, 212, 255, 0.15) 0%, rgba(0, 212, 255, 0.08) 100%);
  box-shadow: 0 0 12px rgba(0, 212, 255, 0.25);

}

.volume-control-mini {

  display: flex;

  align-items: center;
  gap: 4px;
  padding: 0 6px;
  border-left: 1px solid #2a2a2a;
  margin-left: 2px;
  color: #888;

}

.mini-slider {

  -webkit-appearance: none;
  width: 40px;
  height: 3px;
  background: #2a2a2a;
  border-radius: 2px;

  outline: none;

}

.mini-slider::-webkit-slider-thumb {

  -webkit-appearance: none;
  width: 10px;
  height: 10px;
  background: #00d4ff;
  border-radius: 50%;

  cursor: pointer;
  box-shadow: 0 0 5px rgba(0, 212, 255, 0.5);

}

.mini-value {
  font-size: 9px;
  font-family: 'SF Mono', monospace;
  color: #00d4ff;
  min-width: 18px;

}

.live-stream-preview {

  image-rendering: -webkit-optimize-contrast;
  /* 提高图片在浏览器中的渲染清晰度 */


  image-rendering: crisp-edges;

  object-fit: contain;
  background: #000;

}

.center-panel {

  display: flex;

  flex-direction: column;
  gap: 8px;
  min-width: 0;
  height: 679px;

}

.video-area {
  flex: 1;
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%);
  border: 1px solid #2a2a2a;
  border-radius: 16px;

  display: flex;

  flex-direction: column;

  overflow: hidden;

  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5),
  inset 0 0 60px rgba(0, 0, 0, 0.3);

}

.video-preview {
  flex: 1;

  position: relative;

  overflow: hidden;
  background: #000;

  display: flex;

  align-items: center;

  justify-content: center;

}

.video-controls-new {
  padding: 12px 16px;
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%);
  border-top: 1px solid #2a2a2a;

  display: flex;

  flex-direction: column;
  gap: 12px;

}

.progress-container {
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;

  cursor: pointer;

  position: relative;

  transition: all 0.2s ease;

}

.progress-container:hover {
  height: 6px;
  background: rgba(255, 255, 255, 0.15);

}

.progress-bar-bg {
  width: 100%;
  height: 100%;

  position: relative;

}

.progress-bar-fill {
  height: 100%;
  background: #00d4ff;
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.4);
  pointer-events: none;
}

.controls-main-row {

  display: flex;

  align-items: center;

  justify-content: space-between;

}

.control-btn-new {
  background: linear-gradient(180deg, #202020 0%, #1a1a1a 100%);
  border: 1px solid #2a2a2a;
  color: #a0a0a0;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 12px;

  cursor: pointer;

  transition: all 0.2s ease;

  display: flex;

  align-items: center;

  justify-content: center;

}

.control-btn-new:hover {
  border-color: #3a3a3a;
  color: #fff;

}

.control-btn-new.active {
  background: linear-gradient(180deg, rgba(0, 212, 255, 0.15) 0%, rgba(0, 212, 255, 0.08) 100%);
  border-color: #00d4ff;
  color: #00d4ff;
  box-shadow: 0 0 12px rgba(0, 212, 255, 0.2);

}

.control-btn-new.play {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  padding: 0;
  background: linear-gradient(135deg, #00d4ff 0%, #00a8cc 100%);

  border: none;
  color: #000;

}

.control-btn-new.play:hover {
  transform: scale(1.05);
  box-shadow: 0 0 15px rgba(0, 212, 255, 0.4);

}

.time-display-new {
  font-size: 12px;
  color: #888;
  font-family: 'SF Mono', monospace;
  margin-left: 4px;

}

.preset-select-new {
  background: #1a1a1a;
  border: 1px solid #2a2a2a;
  color: #a0a0a0;
  padding: 5px 10px;
  border-radius: 8px;
  font-size: 12px;

  outline: none;

  cursor: pointer;

}

/* 设备设置区样式 */
.device-settings-area {
  margin-top: 4px;
  padding: 12px;
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%);
  border-radius: 12px;
  border: 1px solid #2a2a2a;

  display: flex;

  flex-direction: column;
  gap: 10px;
  width: 100%;

  box-sizing: border-box;

}

.device-row {

  display: flex;

  align-items: center;
  gap: 8px;
  width: 100%;

}

.device-label-box {
  background: #252525;
  color: #a0a0a0;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 11px;
  min-width: 80px;

  text-align: center;
  border: 1px solid #333;

  white-space: nowrap;

}

.device-input, .device-select {
  flex: 1;
  background: #111;
  border: 1px solid #2a2a2a;
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;

  outline: none;
  min-width: 0;
  /* 防止 flex 子元素溢出 */


  transition: all 0.2s;

}


.device-input:focus, .device-select:focus {
  border-color: #00d4ff;
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.2);

}

.device-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  border: none;
  color: #000;
  font-weight: 600;
  transition: all 0.2s;
  min-width: 70px;
  white-space: nowrap;

}

.device-action-btn.apply {
  background: linear-gradient(135deg, #00d4ff 0%, #00a8cc 100%);
  color: #000;
  font-weight: 600;

}

.device-action-btn.apply:hover {
  transform: translateY(-1px);
  box-shadow: 0 0 15px rgba(0, 212, 255, 0.4);

}

.device-action-btn.projector {
  background: linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%);
  color: #fff;

}

.device-action-btn.projector:hover {
  transform: translateY(-1px);
  box-shadow: 0 0 15px rgba(162, 155, 254, 0.4);

}

.device-action-btn.apply.is-loading {
  opacity: 0.8;

  cursor: wait;

}

.loading-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;

  animation: spin 1s linear infinite;
  margin-right: 4px;

}

@keyframes spin {
  to {
    transform: rotate(360deg);

  }

}

.device-action-btn.mute {
  background: #252525;
  border: 1px solid #333;
  color: #a0a0a0;

}

.device-action-btn.mute:hover {
  background: #333;
  color: #fff;
  border-color: #444;

}

.video-bg {

  position: relative;

  width: auto;
  height: 100%;
  aspect-ratio: 9 / 16;
  background: #000;

  display: flex;

  align-items: center;

  justify-content: center;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.9);

  overflow: hidden;
  /* 确保内部元素不溢出 9:16 区域 */
}

.video-element {
  width: 100%;
  height: 100%;

  object-fit: cover;

  position: relative;
  z-index: 1;

}

/* 上下文字滚动 */
.text-scroll-container {

  position: absolute;
  z-index: 100;

  cursor: move;

  user-select: none;

  overflow: hidden;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  border-radius: 0.5em;
  padding: 0.5em;
  border: 1px solid rgba(255, 255, 255, 0.1);

}

.text-scroll-list {

  display: flex;

  flex-direction: column;

  animation: text-scroll-up linear infinite;

}

.text-scroll-item {

  white-space: nowrap;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
  line-height: 1.5;

}

@keyframes text-scroll-up {
  0% {
    transform: translateY(0);

  }

  100% {
    transform: translateY(-50%);

  }

}

.marquee-container {

  position: absolute;

  white-space: nowrap;
  padding: 0.4em 0.8em;
  border-radius: 0.3em;

  cursor: move;
  z-index: 10;

  overflow: hidden;
  max-width: 90%;

}

.marquee-content {

  display: inline-block;

  animation: marquee-scroll linear infinite;

}

.marquee-item {

  display: inline-block;
  padding-right: 40px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);

}

@keyframes marquee-scroll {
  0% {
    transform: translateX(0);

  }

  100% {
    transform: translateX(-50%);

  }

}

.flash-text-container {

  position: absolute;
  padding: 0.3em 0.8em;
  border-radius: 0.4em;

  cursor: move;
  z-index: 11;
  font-weight: 800;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);

  animation: flash-breathing ease-in-out infinite;

  white-space: nowrap;

}

@keyframes flash-breathing {
  0%, 100% {
    opacity: 1;

    transform: scale(1);

  }

  50% {
    opacity: 0.2;

    transform: scale(0.95);

  }

}

/* 热卖特效容器 */
.hot-sale-container {

  position: absolute;
  z-index: 100;

  cursor: move;

  user-select: none;

  animation: hot-sale-entry 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;

}

.hot-sale-wrap {

  position: relative;

  display: flex;

  align-items: center;

  justify-content: flex-start;
  height: 32px;
  background: linear-gradient(270.02deg, rgba(255, 177, 26, 0) 3.96%, rgba(255, 177, 26, 0.6) 20.3%, rgba(255, 177, 26, 0.8) 86.14%);
  border-radius: 16px 0 0 16px;

  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
  padding-right: 10px;

}

.hot-sale-wrap.is-popping {
  transform: scale(1.2);

}

.hot-sale-img {
  height: 32px;

  width: auto;

  display: block;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));

}

.hot-sale-x {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 29px;
  margin-left: 4px;
  font-style: italic !important;

  font-family: PingFang SC, sans-serif;

  position: relative;
  top: 3px;

}

.hot-sale-count {

  position: relative;
  color: #fff;
  font-size: 26px;
  line-height: 29px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);

  pointer-events: none;

  font-style: italic;
  font-weight: 700;
  margin-left: 5px;

  font-family: PingFang SC, sans-serif;

}

@keyframes hot-sale-entry {
  from {
    opacity: 0;

    transform: translateX(- 50 px) scale(0.8);

  }

  to {
    opacity: 1;

    transform: translateX(0) scale(1);

  }

}

/* 库存飘屏特效 */
.inventory-container {

  position: absolute;
  z-index: 99;

  cursor: move;

  user-select: none;

  animation: hot-sale-entry 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;

}

.inventory-wrap {

  position: relative;

  display: flex;

  align-items: center;

  justify-content: flex-start;
  height: 32px;
  background: linear-gradient(89.99deg, rgba(255, 69, 181, .8) 10.09%, rgba(255, 69, 181, .7) 79.16%, rgba(255, 69, 181, 0) 97.76%);
  border-radius: 16px 0 0 16px;
  padding-right: 12px;
  color: #fff;

  font-family: PingFang SC, sans-serif;

  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);

}

.inventory-wrap.is-popping {
  transform: scale(1.15);

}

.inventory-img {
  height: 32px;

  width: auto;

  display: block;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));

}

.inventory-x {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 29px;
  margin-left: 4px;
  font-style: italic !important;

  font-family: PingFang SC, sans-serif;

  position: relative;
  top: 3px;

}

.inventory-count {

  position: relative;
  color: #fff;
  font-size: 24px;
  line-height: 29px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);

  pointer-events: none;

  font-style: italic;
  font-weight: 700;
  margin-left: 5px;

  font-family: PingFang SC, sans-serif;
  top: 1px;

}

/* 购买飘屏样式 */
.purchase-banner {
  height: 64px;
  width: 100%;
  background: linear-gradient(#252632 68.75%, rgba(37, 38, 50, 0) 100%);

  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;

  display: flex;

  align-items: center;

  justify-content: center;

  animation: purchase-banner-entry 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;

}

@keyframes purchase-banner-entry {
  from {
    transform: translateY(100%);

    opacity: 0;

  }

  to {
    transform: translateY(0);

    opacity: 1;

  }

}

.purchase-banner-content {

  display: flex;

  align-items: center;
  padding: 0 20px;

}

.purchase-user {
  color: #ffeb3b;
  font-weight: 700;

  white-space: nowrap;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);

}


.image-overlay-element {

  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;

  object-fit: cover;
  /* 铺满全屏 */


  pointer-events: none;
  z-index: 6;

  transition: opacity 0.3s ease;

}

.camera-wrapper {

  position: absolute;
  border-radius: 4px;
  background: transparent;

  cursor: pointer;

}

.camera-wrapper.camera-selected {
  border: 2px solid #00d4ff;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.3);

}

.camera-video-element {
  width: 100%;
  height: 100%;

  object-fit: cover;

  pointer-events: none;

}

.camera-overlay {

  position: absolute;
  inset: 0;

  cursor: move;
  z-index: 5;

}

.resize-handle {

  position: absolute;
  width: 12px;
  height: 12px;
  background: #00d4ff;
  border: 2px solid #000;
  border-radius: 2px;
  z-index: 10;

}

.resize-handle-tl {
  top: -6px;
  left: -6px;

  cursor: nwse-resize;

}

.resize-handle-tr {
  top: -6px;
  right: -6px;

  cursor: nesw-resize;

}

.resize-handle-bl {
  bottom: -6px;
  left: -6px;

  cursor: nesw-resize;

}

.resize-handle-br {
  bottom: -6px;
  right: -6px;

  cursor: nwse-resize;

}

.resize-handle:hover {
  background: #00ffff;
  box-shadow: 0 0 8px rgba(0, 255, 255, 0.6);

}

.video-grid {

  display: none;

}

.video-overlay {

  position: absolute;
  top: 16px;
  right: 16px;

  display: flex;
  gap: 12px;

  z-index: 9999;
}

.live-badge {
  background: linear-gradient(135deg, #ff4757 0%, #cc3945 100%);

  color: white;
  font-size: 10px;
  font-weight: 700;
  padding: 6px 12px;
  border-radius: 6px;

  display: flex;

  align-items: center;
  gap: 6px;

  animation: livePulse 1.5s infinite;

  box-shadow: 0 0 20px rgba(255, 71, 87, 0.45),
  0 2px 8px rgba(0, 0, 0, 0.3);

}

.live-dot {
  width: 6px;
  height: 6px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 5px #fff;

}

/* Toast 样式 */
.toast-notification {

  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;

  pointer-events: none;

}

.toast-content {
  background: rgba(20, 20, 20, 0.9);
  backdrop-filter: blur(8px);
  border: 1px solid #333;
  color: #fff;
  padding: 10px 20px;
  border-radius: 12px;
  font-size: 13px;

  display: flex;

  align-items: center;
  gap: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);

}

.toast-notification.success .toast-content {
  border-color: #00d4ff;
  color: #00d4ff;

}

.toast-notification.error .toast-content {
  border-color: #ff4757;
  color: #ff4757;

}

/* Transition 动画 */
.toast-enter-active,
.toast-leave-active {

  transition: all 0.3s ease;

}

.toast-enter-from {
  opacity: 0;
  transform: translate(-50%, 20px);

}

.toast-leave-to {
  opacity: 0;
  transform: translate(-50%, -20px);

}

@keyframes livePulse {
  0%, 100% {
    opacity: 1;

    transform: scale(1);

  }

  50% {
    opacity: 0.7;

    transform: scale(1.02);

  }

}

@keyframes shake-micro {
  0% {
    transform: translate(0, 0);

  }

  20% {
    transform: translate(- 1 px, 0.5px);

  }

  40% {
    transform: translate(- 1 px, - 0.5 px);

  }

  60% {
    transform: translate(1px, 0.5px);

  }

  80% {
    transform: translate(1px, - 0.5 px);

  }

  100% {
    transform: translate(0, 0);

  }

}

@keyframes shake-medium {
  0% {
    transform: translate(0, 0);

  }

  20% {
    transform: translate(- 3 px, 1.5px);

  }

  40% {
    transform: translate(- 3 px, - 1.5 px);

  }

  60% {
    transform: translate(3px, 1.5px);

  }

  80% {
    transform: translate(3px, - 1.5 px);

  }

  100% {
    transform: translate(0, 0);

  }

}

@keyframes shake-heavy {
  0% {
    transform: translate(0, 0);

  }

  20% {
    transform: translate(- 6 px, 3px);

  }

  40% {
    transform: translate(- 6 px, - 3 px);

  }

  60% {
    transform: translate(6px, 3px);

  }

  80% {
    transform: translate(6px, - 3 px);

  }

  100% {
    transform: translate(0, 0);

  }

}

.motion-wrapper, .shake-wrapper {

  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;

  display: block;
  /* 改为 block，内部元素使用绝对定位层叠 */


  pointer-events: none;
  z-index: 1;

}

.effects-canvas {

  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;

  pointer-events: none;
  z-index: 5;

}

/* 强制预览画面和视频占满容器 */
.video-element, .live-stream-preview {

  position: absolute;
  /* 确保在容器内层叠 */
  inset: 0;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;

  pointer-events: auto;

}

.video-loading-overlay {

  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: center;
  z-index: 20;
  backdrop-filter: blur(4px);

}

.loading-spinner-large {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 212, 255, 0.1);
  border-top: 3px solid #00d4ff;
  border-radius: 50%;

  animation: spin 1s linear infinite;
  margin-bottom: 16px;

}

.loading-text {
  color: #00d4ff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;

}

/* 实时抖动关键样式 - 强制使用 !important 确保不被覆盖 */
.is-shaking-micro {
  animation: shake-micro 0.2s infinite linear !important;

}

.is-shaking-medium {
  animation: shake-medium 0.15s infinite linear !important;

}

.is-shaking-heavy {
  animation: shake-heavy 0.12s infinite linear !important;

}

.video-element {

  pointer-events: auto;

}

.viewer-count {
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(8px);
  color: #a0a0a0;
  font-size: 11px;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);

}

.video-controls {

  display: none;

}

.control-left {

  display: flex;

  align-items: center;
  gap: 10px;

}

.control-right {

  display: flex;

  align-items: center;

  margin-left: auto;

}

.volume-control-mini.main-player-volume {
  background: rgba(255, 255, 255, 0.05);
  padding: 4px 12px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  height: 32px;

}

.volume-control-mini.main-player-volume:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(0, 212, 255, 0.3);

}

.preset-select {
  background: linear-gradient(180deg, #1a1a1a 0%, #151515 100%);
  border: 1px solid #2a2a2a;
  color: #a0a0a0;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 11px;

  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);

}

.control-btn {
  background: linear-gradient(180deg, #1a1a1a 0%, #151515 100%);
  border: 1px solid #2a2a2a;
  color: #a0a0a0;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 11px;

  cursor: pointer;

  transition: all 0.2s ease;

}

.control-btn.active {
  background: linear-gradient(180deg, rgba(0, 212, 255, 0.18) 0%, rgba(0, 212, 255, 0.1) 100%);
  border-color: #00d4ff;
  color: #00d4ff;
  box-shadow: 0 0 15px rgba(0, 212, 255, 0.25);

}

.control-btn:hover:not(.play) {
  border-color: #3a3a3a;

}

.control-btn.play {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff4757 0%, #cc3945 100%);

  border: none;

  color: white;

  display: flex;

  align-items: center;

  justify-content: center;

  box-shadow: 0 4px 15px rgba(255, 71, 87, 0.45),
  0 2px 8px rgba(0, 0, 0, 0.3);

  transition: all 0.2s ease;

}

.control-btn.play:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(255, 71, 87, 0.55),
  0 2px 8px rgba(0, 0, 0, 0.3);

}

.time-display {
  font-size: 11px;
  color: #808080;
  font-family: 'SF Mono', monospace;

}

.fade-row {

  display: flex;

  align-items: center;

  justify-content: flex-start;
  margin-bottom: 12px;
  gap: 16px;
  font-size: 13px;
  color: #b0b0b0;

  white-space: nowrap;

}

.fade-row input {
  width: 50px;
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%);
  border: 1px solid #2a2a2a;
  color: #ffffff;
  padding: 6px 6px;
  border-radius: 5px;
  font-size: 13px;

  text-align: center;
  font-family: 'SF Mono', monospace;

  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);

  transition: border-color 0.2s ease;

}

.fade-row input::-webkit-inner-spin-button,
.fade-row input::-webkit-outer-spin-button {

  -webkit-appearance: none;
  margin: 0;
  opacity: 0;

}

.fade-row input:focus::-webkit-inner-spin-button,
.fade-row input:focus::-webkit-outer-spin-button {

  -webkit-appearance: inner-spin-button;
  opacity: 1;

  background: transparent;

  cursor: pointer;

}

.fade-row input:focus {

  outline: none;
  border-color: #00d4ff;
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.25), inset 0 1px 2px rgba(0, 0, 0, 0.3);

}

.frame-info {

  display: flex;

  justify-content: space-between;

  align-items: center;
  padding-top: 8px;
  border-top: 1px solid #2a2a2a;
  font-size: 12px;
  color: #808080;

}

.frame-info strong {
  color: #00d4ff;

}

.frame-info .status {
  padding: 2px 8px;
  border-radius: 10px;
  background: #2a2a2a;
  color: #808080;
  font-size: 11px;

}

.frame-info .status.active {
  background: rgba(0, 212, 255, 0.2);
  color: #00d4ff;

}

.time-row {

  display: flex;

  align-items: center;

  justify-content: flex-start;
  gap: 16px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #b0b0b0;

  flex-wrap: wrap;

  white-space: nowrap;

}

.fade-row:last-child,
.time-row:last-child {
  margin-bottom: 0;

}

.time-row input {
  width: 50px;
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%);
  border: 1px solid #2a2a2a;
  color: #ffffff;
  padding: 6px 6px;
  border-radius: 5px;
  font-size: 13px;

  text-align: center;
  font-family: 'SF Mono', monospace;

  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);

  transition: border-color 0.2s ease;

}

.time-row input::-webkit-inner-spin-button,
.time-row input::-webkit-outer-spin-button {

  -webkit-appearance: none;
  margin: 0;
  opacity: 0;

}

.time-row input:focus::-webkit-inner-spin-button,
.time-row input:focus::-webkit-outer-spin-button {

  -webkit-appearance: inner-spin-button;
  opacity: 1;

  background: transparent;

  cursor: pointer;

}

.time-row input:focus {

  outline: none;
  border-color: #00d4ff;
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.25), inset 0 1px 2px rgba(0, 0, 0, 0.3);

}

/* Responsive handling */
@media (max-width: 1400px) {
  .main-content {
    grid-template-columns: minmax(0, 400px) minmax(0, 1fr) minmax(0, 400px);

  }
}

@media (max-width: 1200px) {
  .main-content {
    grid-template-columns: minmax(0, 380px) minmax(0, 1fr) minmax(0, 380px);

  }
}


.cyber-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.cyber-modal {
  position: relative;
  width: 100%;
  max-width: 480px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow:
      0 0 60px rgba(0, 212, 255, 0.2),
      inset 0 0 40px rgba(0, 0, 0, 0.5);
  animation: modalSlideIn 0.3s ease-out;
}

.phone-broadcast-modal {
  max-width: 520px;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.decorative-corner {
  position: absolute;
  width: 20px;
  height: 20px;
}

.decorative-corner::before,
.decorative-corner::after {
  content: '';
  position: absolute;
  background: var(--accent);
  opacity: 0.6;
}

.decorative-corner.top-left {
  top: 8px;
  left: 8px;
}
.decorative-corner.top-left::before {
  top: 0;
  left: 0;
  width: 2px;
  height: 16px;
}
.decorative-corner.top-left::after {
  top: 0;
  left: 0;
  width: 16px;
  height: 2px;
}

.decorative-corner.top-right {
  top: 8px;
  right: 8px;
}
.decorative-corner.top-right::before {
  top: 0;
  right: 0;
  width: 2px;
  height: 16px;
}
.decorative-corner.top-right::after {
  top: 0;
  right: 0;
  width: 16px;
  height: 2px;
}

.decorative-corner.bottom-left {
  bottom: 8px;
  left: 8px;
}
.decorative-corner.bottom-left::before {
  bottom: 0;
  left: 0;
  width: 2px;
  height: 16px;
}
.decorative-corner.bottom-left::after {
  bottom: 0;
  left: 0;
  width: 16px;
  height: 2px;
}

.decorative-corner.bottom-right {
  bottom: 8px;
  right: 8px;
}
.decorative-corner.bottom-right::before {
  bottom: 0;
  right: 0;
  width: 2px;
  height: 16px;
}
.decorative-corner.bottom-right::after {
  bottom: 0;
  right: 0;
  width: 16px;
  height: 2px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px 16px;
  border-bottom: 1px solid rgba(0, 212, 255, 0.2);
}

.terminal-prompt {
  display: flex;
  align-items: center;
  gap: 8px;
}

.prompt-symbol {
  color: var(--accent);
  font-family: 'JetBrains Mono', monospace;
  font-weight: bold;
  animation: blinkPrompt 1.5s ease-in-out infinite;
}

@keyframes blinkPrompt {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

.prompt-text {
  font-family: 'Orbitron', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  letter-spacing: 1px;
}

.close-button {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease, transform 0.2s ease;
}

.close-button:hover {
  color: var(--accent);
  transform: rotate(90deg);
}

.modal-body {
  padding: 24px 32px;
}

.phone-config-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.config-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.config-item.toggle-item {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

.config-label {
  font-size: 13px;
  color: var(--text-secondary);
  font-family: 'Orbitron', sans-serif;
  letter-spacing: 0.5px;
}

.config-input,
.config-select {
  width: 100%;
  padding: 12px 16px;
  background: rgba(0, 212, 255, 0.05);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 14px;
  font-family: 'JetBrains Mono', monospace;
  transition: all 0.3s ease;
}

.config-input:focus,
.config-select:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
}

.config-input:disabled {
  background: rgba(0, 212, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  cursor: not-allowed;
  border-color: rgba(0, 212, 255, 0.3);
}

.config-select {
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cpath d='M3 5L6 8L9 5' stroke='%2300d4ff' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  padding-right: 40px;
}

.cyber-switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
  cursor: pointer;
}

.cyber-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-track {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 212, 255, 0.2);
}

.switch-track::before {
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  background: rgba(0, 212, 255, 0.05);
  border-radius: 18px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.switch-thumb {
  position: absolute;
  top: 50%;
  left: 3px;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.cyber-switch input:checked + .switch-track {
  background: var(--accent);
  border-color: var(--accent);
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.4);
}

.cyber-switch input:checked + .switch-track::before {
  opacity: 1;
}

.cyber-switch input:checked + .switch-track .switch-thumb {
  transform: translate(24px, -50%);
  background: white;
}

.modal-footer {
  padding: 16px 32px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.cyber-button {
  padding: 12px 32px;
  border: none;
  border-radius: 8px;
  font-family: 'Orbitron', sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}

.cyber-button.primary {
  background: linear-gradient(135deg, var(--accent), #0099cc);
  color: #000;
}

.cyber-button.secondary {
  background: rgba(255, 255, 255, 0.05);
  color: var(--text-secondary);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.cyber-button.primary::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.cyber-button.primary:hover::before {
  left: 100%;
}

.cyber-button.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px var(--accent-glow);
}

.cyber-button.secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
}

.button-text {
  font-size: 13px;
}

.button-accent {
  font-size: 10px;
  opacity: 0.7;
}
</style>
